// runSaveConfig — the global Save flow (diff + PATCH per wired section) — extracted verbatim from WebshopConfigScreen.js. The screen passes
// its state setters/refs/props in one ctx object; closure semantics are
// identical to the inline version (ctx is rebuilt per call, so every value is
// as current as the render that triggered it).

import SftGlobalData from '../../../library/SftGlobalData';
import { toLangCsv } from '../WebshopLanguagesContext';
import { storeFormToColumns } from '../data/stores';
import { serializeChipsToCsv, serializeChipsToTemplate, withSavedTitleUrl } from '../style/cards/ProductTitleAndUrlCard';
import { cartDisplayInfoToSetting, newestFieldToSetting, formatAddressGeo, HOME_BLOCK_FLAGS, BANNER_POS_TO_BACKEND, BRANDS_LAYOUT_TO_STYLE, CARD_CONTENT, DEFAULT_FILTER_SETTING, DEFAULT_FONTS, contentBodiesToSend, dynPageBodyToSend, DYN_POS_TO_BACKEND, OVERIGE_STYLE_TO_LAYOUT, STYLE_COLOR_PATHS, bannerRowToForm, brandContentFormToBody, cadeaubonToSettings, containerBodyContent, containerFormToBody, customerGroupRowToForm, customerGroupToColumns, dynRowToPage, fileToBase64, layoutRowToForm, placeholderRowToForm, processingToSettings, readByPath, shopImageBase, sideFilterJsonKey, sortRuleToCsv, syncToSettings, zoomSpeedToMs, slideRowToForm, gridCellRowToForm, rowsByLang, contentsRowToPage, contentsRowToColumn, linkRowToFooter, linkRowToSocial } from './configHelpers';
import { IMAGE_ROW, LAYOUT_ROW, PLAIN_ID_ROW, SERVER_ID_ROW, buildSaveReport, opSucceeded, reconcileList, sectionOfOp } from './saveSections';

// Resolves to the save report ({ ok, saved, failed, warnings } — see
// saveSections.buildSaveReport), or undefined when nothing was sent.
export const runSaveConfig = async (ctx) => {
    const {
        STATIC_PAGE_DEFAULT,
        allStoreCodesForSync,
        banners,
        bannersDirty,
        blankColumn,
        brandContentDirty,
        brandContentSaveRef,
        brandContentSessionRef,
        setBrandContentDirty,
        brandsConfig,
        brandsConfigDirty,
        cadeaubonConfig,
        cadeaubonConfigDirty,
        cadeaubonLayouts,
        cadeaubonLayoutsDirty,
        cadeaubonPlaceholders,
        cadeaubonPlaceholdersDirty,
        cards,
        cardsDirty,
        carouselConfig,
        carouselDirty,
        carouselImgBaseRef,
        containerBlocks,
        containersDirty,
        customerCategoryGroups,
        customerGroupsDirty,
        desiredHomeSectionsOrder,
        showLanding,
        desiredPage404Order,
        dynamicPages,
        dynamicPagesDirty,
        extraFooterConfig,
        extraFooterDirty,
        fireGenerateStatics,
        footerConfig,
        footerDirty,
        globalWidths,
        globalWidthsDirty,
        gridImgBaseRef,
        groupsFilterConfig,
        groupsFilterDirty,
        headerLogoConfig,
        headerLogoDirty,
        hoursSeparator,
        imageGalleryConfig,
        imageGalleryDirty,
        imageGridConfig,
        imageGridDirty,
        layoutImgBaseRef,
        looksConfig,
        looksConfigDirty,
        looksCtaIdRef,
        mapSettings,
        mapSettingsDirty,
        navbarOrder,
        navbarOrderDirty,
        navigationConfig,
        navigationDirty,
        order404Dirty,
        orderDirty,
        showLandingDirty,
        originalBannersRef,
        originalBrandsConfigRef,
        originalBrandsRawJsonRef,
        originalCadeaubonConfigRef,
        originalCadeaubonLayoutsRef,
        originalCardsRef,
        originalCarouselConfigRef,
        originalContainerIdsRef,
        originalCustomerGroupsRef,
        originalDynamicPagesRef,
        originalExtraFooterConfigRef,
        originalFooterConfigRef,
        originalGlobalWidthsRef,
        originalGroupsFilterConfigRef,
        originalHeaderLogoConfigRef,
        originalHoursSeparatorRef,
        originalImageGalleryConfigRef,
        originalImageGridConfigRef,
        originalLooksConfigRef,
        originalMapSettingsRef,
        originalNavbarOrderRef,
        originalNavigationConfigRef,
        originalOverigeConfigRef,
        originalPlaceholdersRef,
        originalProcChequeRef,
        homeBlockFlagsRef,
        originalProcessingConfigRef,
        originalProductCardConfigRef,
        originalProductDetailInfoConfigRef,
        originalProductGridConfigRef,
        originalStaticPagesRef,
        originalStoresRef,
        originalStyleSettingsRef,
        originalSyncConfigRef,
        originalTicketModuleRef,
        overigeConfig,
        overigeConfigDirty,
        processingConfig,
        processingConfigDirty,
        productCardConfig,
        productCardDirty,
        productDetailInfoConfig,
        productDetailInfoDirty,
        productGridConfig,
        productGridDirty,
        productHoverMaxRowsRef,
        cartLayout,
        originalCartLayoutRef,
        props,
        separatorDirty,
        setActive,
        setActive404,
        setAvailable,
        setAvailable404,
        setBanners,
        setCadeaubonLayouts,
        setCadeaubonPlaceholders,
        setCarouselConfig,
        setConfigSaving,
        setContainersDirty,
        setCustomerCategoryGroups,
        setDynamicPages,
        setFooterConfig,
        setHeaderLogoConfig,
        setHomeSectionsOrder,
        setSavedShowLanding,
        setImageGridConfig,
        setPage404SectionsOrder,
        setSavedTick,
        setSaveReport,
        staticPages,
        setStaticPages,
        setExtraFooterConfig,
        staticPagesDirty,
        stores,
        storesDirty,
        styleSettings,
        styleSettingsDirty,
        syncConfig,
        syncConfigDirty,
        validateCustomerId,
    } = ctx;
        const webshopId = props.selectedWebshop?.id;
        if (!webshopId || !props.api) {
            if (props.notify) props.notify('No webshop selected', 4000, 'top-right', props.theme, 1);
            return;
        }
        if (!orderDirty && !showLandingDirty && !productGridDirty && !productCardDirty && !styleSettingsDirty &&
            !groupsFilterDirty && !globalWidthsDirty && !headerLogoDirty && !navigationDirty &&
            !footerDirty && !extraFooterDirty && !imageGalleryDirty && !productDetailInfoDirty &&
            !carouselDirty && !imageGridDirty && !staticPagesDirty && !storesDirty && !separatorDirty && !mapSettingsDirty && !cardsDirty && !brandsConfigDirty && !dynamicPagesDirty && !bannersDirty && !looksConfigDirty && !overigeConfigDirty && !cadeaubonConfigDirty && !cadeaubonPlaceholdersDirty && !cadeaubonLayoutsDirty && !processingConfigDirty && !customerGroupsDirty && !syncConfigDirty && !order404Dirty && !navbarOrderDirty && !containersDirty && !brandContentDirty) {
            if (props.notify) props.notify('No changes to save', 3000, 'top-right', props.theme, 3);
            return;
        }
        setConfigSaving(true);
        try {
            // Build a single list of PATCH calls so all changes (HOME_SECTIONS_ORDER,
            // grid settings, future modal saves) ride the same proxy and the same
            // dirty-reset path. `b` for boolean → '1'/'0' coercion mirrors the
            // mini-api's expected string shape.
            const b = (v) => (v ? '1' : '0');

            // ── Product containers — run FIRST ─────────────────────────────
            // Containers are referenced by id in HOME/404_SECTIONS_ORDER, so they
            // must be created before those order strings are saved: a new
            // container's client id (`container_<ts>`) is remapped to its real
            // `pd_cnt-<id>` here and spliced into the order below. Body content is
            // sent (POST + PATCH) only when the editor actually holds an authored
            // design (containerBodyContent guards this), so an update that didn't
            // touch the body leaves the existing content untouched, never wiped.
            const containerIdRemap = {};
            // Container requests that failed, and sections that could not be
            // saved for a reason other than a failed request of their own —
            // both end up in the save report.
            const containerFailed = [];
            const extraFailures = [];
            // An image that did not upload, per section — also for the report.
            const warnings = [];
            let orderBlocked = false;
            if (containersDirty) {
                const curBlocks = containerBlocks();
                const curIds = new Set(curBlocks.map(bk => bk.id));
                const delOps = [...originalContainerIdsRef.current]
                    .filter(id => !curIds.has(id))
                    .map(id => ({ kind: 'container-del', blockId: id, method: 'DELETE', path: `/product-containers/${String(id).slice('pd_cnt-'.length)}` }));
                const upsertOps = curBlocks.map(bk => {
                    const body = { ...containerFormToBody(bk.config), ...containerBodyContent(bk.config) };
                    if (String(bk.id).startsWith('pd_cnt-')) {
                        return { kind: 'container-upd', method: 'PATCH', path: `/product-containers/${String(bk.id).slice('pd_cnt-'.length)}`, body };
                    }
                    return { kind: 'container-new', tempId: bk.id, method: 'POST', path: '/product-containers', body };
                });
                const ops = [...delOps, ...upsertOps];
                if (ops.length) {
                    const cres = await Promise.all(ops.map(op =>
                        SftGlobalData.post('webshop&action=proxy', {
                            key: props.api, webshop_id: webshopId,
                            sftUserId: props.login?.sft_user_id, user: props.login?.login,
                            method: op.method, path: op.path, body: op.body,
                        }).then(r => ({ ...op, response: r }))
                          .catch(e => ({ ...op, response: { success: false, message: e?.message || 'network error' } }))));
                    cres.forEach(r => {
                        if (r.kind === 'container-new' && opSucceeded(r) && r.response?.data?.id != null) {
                            containerIdRemap[r.tempId] = `pd_cnt-${r.response.data.id}`;
                        }
                    });
                    const cfailed = cres.filter(r => !opSucceeded(r));
                    if (cfailed.length) {
                        containerFailed.push(...cfailed);
                        // Keep what DID go through, so a retry repeats only what
                        // failed: created containers get their real id in the
                        // block lists and the baseline, removed ones leave it.
                        if (Object.keys(containerIdRemap).length) {
                            const remapBlock = (bk) => (containerIdRemap[bk.id] ? { ...bk, id: containerIdRemap[bk.id] } : bk);
                            setActive(l => l.map(remapBlock));
                            setAvailable(l => l.map(remapBlock));
                            setActive404(l => l.map(remapBlock));
                            setAvailable404(l => l.map(remapBlock));
                        }
                        const nextIds = new Set(originalContainerIdsRef.current);
                        cres.forEach(r => {
                            if (!opSucceeded(r)) return;
                            if (r.kind === 'container-new' && containerIdRemap[r.tempId]) nextIds.add(containerIdRemap[r.tempId]);
                            if (r.kind === 'container-del') nextIds.delete(r.blockId);
                        });
                        originalContainerIdsRef.current = nextIds;
                        // A container that could not be created still carries its
                        // temporary id — never write that into a page order.
                        orderBlocked = cfailed.some(r => r.kind === 'container-new');
                    }
                }
            }
            // Rewrite an order CSV, replacing any freshly-created container's
            // client id with its real pd_cnt-<id> (no-op when nothing was created).
            const remapOrder = (s) => String(s || '').split(',').map(x => x.trim()).filter(Boolean).map(id => containerIdRemap[id] || id).join(',');

            const patches = [];
            // Set when the look CTA i18n string changes — triggers a localization
            // regenerate after the PATCH so the storefront JSON files update.
            let looksCtaSaved = false;
            // Set when a changed guest customer id fails validation — its setting
            // is then left out of the save (the rest still saves).
            let guestIdSkipped = false;
            if (orderBlocked) {
                if (orderDirty)    extraFailures.push({ section: 'order',    blockedBy: 'containers' });
                if (order404Dirty) extraFailures.push({ section: 'order404', blockedBy: 'containers' });
            }
            if (orderDirty && !orderBlocked) {
                patches.push({
                    kind:  'home-order',
                    path:  '/admin/settings/HOME_SECTIONS_ORDER',
                    value: remapOrder(desiredHomeSectionsOrder),
                });
                // Image grid / brands also need their storefront flag
                // (HOME_BLOCK_FLAGS): on when active, off when not.
                const activeIds = String(desiredHomeSectionsOrder || '').split(',').map(x => x.trim());
                for (const [id, key] of Object.entries(HOME_BLOCK_FLAGS)) {
                    const was = (homeBlockFlagsRef?.current || {})[id];
                    const want = activeIds.includes(id);
                    if (was !== undefined && was !== want) {
                        patches.push({ kind: 'home-order', path: `/admin/settings/${key}`, value: want ? '1' : '0' });
                    }
                }
            }
            // Landing page on/off -- '1'/'0', read as (bool) by the storefront
            // (StartupController enableLanding) and by generate_statics.
            if (showLandingDirty) {
                patches.push({
                    kind:  'show-landing',
                    path:  '/admin/settings/SHOW_LANDING',
                    value: showLanding ? '1' : '0',
                });
            }
            if (order404Dirty && !orderBlocked) {
                patches.push({
                    kind:  'page404-order',
                    path:  '/admin/settings/PAGE_404_SECTIONS_ORDER',
                    value: remapOrder(desiredPage404Order),
                });
            }
            if (productGridDirty) {
                const g  = productGridConfig.productGrid;
                const v  = productGridConfig.variantGrouping;
                const og = originalProductGridConfigRef.current.productGrid;
                const ov = originalProductGridConfigRef.current.variantGrouping;
                // Modal uses 'above'/'below'/'both'; backend expects
                // 'top'/'bottom'/'top-and-bottom'.
                const paginationToBackend = (vv) =>
                    vv === 'above' ? 'top' :
                    vv === 'both'  ? 'top-and-bottom' :
                    'bottom';
                const push = (key, current, original) => {
                    if (String(current) !== String(original)) {
                        patches.push({ kind: 'grid', path: `/admin/settings/${key}`, value: String(current) });
                    }
                };
                push('MAX_COLUMNS_EXPLORE',          g.maxColumns,                                  og.maxColumns);
                push('EXPLORE_PAGINATION_POSITION',  paginationToBackend(g.paginationPosition),     paginationToBackend(og.paginationPosition));
                push('EXPLORE_SHOW_TOTALS',          b(g.showTotalProducts),                        b(og.showTotalProducts));
                // showCardOutline is a frontend-only future-feature flag —
                // no backend key, never patched.
                push('EXPLORE_GROUP_VARIANTS',       b(v.groupAsOne),                               b(ov.groupAsOne));
                push('EXPLORE_SHOW_PRODUCT_VARIANTS',b(v.showSwatches),                             b(ov.showSwatches));
                push('PRODUCT_SHOW_VARIANTS_AMOUNT', v.maxVariants,                                 ov.maxVariants);
            }
            if (productCardDirty) {
                const c  = productCardConfig;
                const oc = originalProductCardConfigRef.current;
                // line composition: chips → space-separated values per line,
                // joined by ';'. A token chip serialises to its field key, a
                // text chip to its literal text — exactly what the storefront
                // template renderer expects.
                const chipToToken = (c) => (c.text !== undefined ? c.text : c.key) || '';
                const linesToCsv = (cfg) => [
                    (cfg.productInfo?.line1 || []).map(chipToToken).filter(Boolean).join(' '),
                    (cfg.productInfo?.line2 || []).map(chipToToken).filter(Boolean).join(' '),
                    (cfg.productInfo?.line3 || []).map(chipToToken).filter(Boolean).join(' '),
                ].join(';');
                // Switched off → type 'zoom' with the flag off: the storefront
                // swaps to the second image on the type alone (see the loader),
                // so leaving 'second_image' behind would keep the effect on.
                const animTypeToBackend = (img) => (img.animateOnHover && img.animationType === 'fadeAlt' ? 'second_image' : 'zoom');
                const aspectStr = (cfg) => `${cfg.image.aspectWidth}/${cfg.image.aspectHeight}`;
                const push = (key, current, original) => {
                    if (String(current) !== String(original)) {
                        patches.push({ kind: 'card', path: `/admin/settings/${key}`, value: String(current) });
                    }
                };
                push('PRODUCT_DISPLAY_INFO',          linesToCsv(c),                          linesToCsv(oc));
                push('PRODUCT_SHOW_DIVIDER',          b(c.productInfo.showDivider),           b(oc.productInfo.showDivider));
                push('PRODUCT_DETAILS_ALIGNMENT',     c.productInfo.align,                    oc.productInfo.align);
                push('EXPLORE_USE_SECOND_IMAGE',      b(c.image.useAlternativeAsMain),        b(oc.image.useAlternativeAsMain));
                push('EXPLORE_USE_IMAGE_FIT',         b(c.image.fillsCard),                   b(oc.image.fillsCard));
                push('EXPLORE_USE_IMAGE_FIT_RATIO',   aspectStr(c),                           aspectStr(oc));
                push('PRODUCT_IMG_RADIUS',            c.image.cornerRounding,                 oc.image.cornerRounding);
                push('ENABLE_PRODUCT_ITEM_ANIMATION', b(c.image.animateOnHover),              b(oc.image.animateOnHover));
                push('PRODUCT_HOVER_ANIM_TYPE',       animTypeToBackend(c.image),             animTypeToBackend(oc.image));
                push('PRODUCT_HOVER_ANIM_ZOOM_SCALE', c.image.zoomScale ?? 140,               oc.image.zoomScale ?? 140);
                push('PRODUCT_HOVER_ANIM_ZOOM_SPEED', c.image.zoomSpeed ?? 300,               oc.image.zoomSpeed ?? 300);
                push('PRODUCT_IMAGE_POSITION',        c.image.imagePosition || 'middle',      oc.image.imagePosition || 'middle');
                push('PRODUCT_HOVER_SIZES',           b(c.sizePreview.enabled),               b(oc.sizePreview.enabled));
                push('PRODUCT_SIZE_OVERLAY_POSITION', c.sizePreview.position,                 oc.sizePreview.position);
                push('PRODUCT_SIZE_OVERLAY_BGC',      c.sizePreview.badgeBg,                  oc.sizePreview.badgeBg);
                push('PRODUCT_SIZE_OVERLAY_FGC',      c.sizePreview.badgeText,                oc.sizePreview.badgeText);
                push('PRODUCT_SIZE_OVERLAY_SIZE',     c.sizePreview.textSize,                 oc.sizePreview.textSize);
                push('PRODUCT_SIZE_SIZE_BORDER',      b(c.sizePreview.showBorder),            b(oc.sizePreview.showBorder));
                // PRODUCT_HOVER_MAX_SIZES — CSV "Y,X". The modal edits X
                // (breedtematen / index [1] = sizes listed in the v1 hover
                // badge); Y (rows / index [0]) was loaded into
                // productHoverMaxRowsRef and is round-tripped untouched.
                {
                    const y = productHoverMaxRowsRef.current;
                    const csvNow  = `${y},${c.sizePreview.maxShown}`;
                    const csvOrig = `${y},${oc.sizePreview.maxShown}`;
                    push('PRODUCT_HOVER_MAX_SIZES', csvNow, csvOrig);
                }
            }
            // Google-font loader writes (POST /admin/generate-font) — own op,
            // ride the shared dispatch below.
            const fontGenerateOps = [];
            if (styleSettingsDirty && originalStyleSettingsRef.current) {
                const orig = originalStyleSettingsRef.current;
                for (const p of STYLE_COLOR_PATHS) {
                    const cur  = readByPath(styleSettings,    p.path);
                    const oCol = readByPath(orig,             p.path);
                    if (cur !== oCol) {
                        patches.push({ kind: 'style', path: `/admin/settings/${p.setting}`, value: String(cur) });
                    }
                }
                // Font — system stack vs Google font. DEFAULT_FONTS hold the
                // system CSS stacks; anything else is a Google font name.
                const curFont = styleSettings.global?.font;
                if (curFont !== orig.global?.font) {
                    const isSystem = DEFAULT_FONTS.some(f => f.family === curFont);
                    if (isSystem) {
                        patches.push({ kind: 'style', path: '/admin/settings/FONT_FAMILY_USE_GOOGLE', value: '0' });
                        patches.push({ kind: 'style', path: '/admin/settings/FONT_FAMILY_GOOGLE',     value: '' });
                        patches.push({ kind: 'style', path: '/admin/settings/FONT_FAMILY',            value: String(curFont) });
                        fontGenerateOps.push({ kind: 'font', method: 'POST', path: '/admin/generate-font', body: { font: '' } });
                    } else {
                        patches.push({ kind: 'style', path: '/admin/settings/FONT_FAMILY_USE_GOOGLE', value: '1' });
                        patches.push({ kind: 'style', path: '/admin/settings/FONT_FAMILY_GOOGLE',     value: String(curFont) });
                        patches.push({ kind: 'style', path: '/admin/settings/FONT_FAMILY',            value: String(curFont) });
                        fontGenerateOps.push({ kind: 'font', method: 'POST', path: '/admin/generate-font', body: { font: String(curFont) } });
                    }
                }
                // Visibility toggles + back-to-top position.
                const v = styleSettings.visibility || {}, ov = orig.visibility || {};
                if (b(v.languageBar) !== b(ov.languageBar)) {
                    patches.push({ kind: 'style', path: '/admin/settings/SHOW_LANGUAGE_BAR', value: b(v.languageBar) });
                }
                if (b(v.footer) !== b(ov.footer)) {
                    patches.push({ kind: 'style', path: '/admin/settings/SHOW_FOOTER', value: b(v.footer) });
                }
                if (toLangCsv(v.visibleLanguages) !== toLangCsv(ov.visibleLanguages)) {
                    patches.push({ kind: 'style', path: '/admin/settings/VISIBILE_LANGUAGES', value: toLangCsv(v.visibleLanguages) });
                }
                if (toLangCsv(v.adminLanguages) !== toLangCsv(ov.adminLanguages)) {
                    patches.push({ kind: 'style', path: '/admin/settings/ADMIN_LANGUAGES', value: toLangCsv(v.adminLanguages) });
                }
                if (v.defaultLanguage && v.defaultLanguage !== ov.defaultLanguage) {
                    patches.push({ kind: 'style', path: '/admin/settings/LANGUAGE_DEFAULT', value: v.defaultLanguage });
                }
                if (v.internalLanguage && v.internalLanguage !== ov.internalLanguage) {
                    patches.push({ kind: 'style', path: '/admin/settings/INTERNAL_LANGUAGE', value: v.internalLanguage });
                }
                if (b(v.recently) !== b(ov.recently)) {
                    patches.push({ kind: 'style', path: '/admin/settings/SHOW_RECENTLY', value: b(v.recently) });
                }
                if (b(v.recentlyOnHome) !== b(ov.recentlyOnHome)) {
                    patches.push({ kind: 'style', path: '/admin/settings/SHOW_RECENTLY_ON_HOME', value: b(v.recentlyOnHome) });
                }
                {
                    const sf = styleSettings.sections?.sideFilter || {}, osf = orig.sections?.sideFilter || {};
                    if (b(sf.mobileActiveParent) !== b(osf.mobileActiveParent)) {
                        patches.push({ kind: 'style', path: '/admin/settings/MOBILE_FILTER_COLOR_PARENT', value: b(sf.mobileActiveParent) });
                    }
                }
                if (v.backToTopPosition !== ov.backToTopPosition) {
                    const bttMap = { left: 'CIRCLE_LEFT', center: 'CIRCLE_MIDDLE', right: 'CIRCLE_RIGHT', hidden: 'NONE', boxTop: 'BOX_TOP', boxBottom: 'BOX_BOTTOM' };
                    patches.push({ kind: 'style', path: '/admin/settings/BACK_TO_TOP_BUTTON', value: bttMap[v.backToTopPosition] || 'CIRCLE_RIGHT' });
                }
                // Custom-hover toggle (the 4 hover colours themselves ride the
                // STYLE_COLOR_PATHS loop above).
                const mCur = styleSettings.sections?.menu || {}, mOrig = orig.sections?.menu || {};
                if (b(mCur.useCustomHover) !== b(mOrig.useCustomHover)) {
                    patches.push({ kind: 'style', path: '/admin/settings/COLOR_USE_CUSTOM_HOVER', value: b(mCur.useCustomHover) });
                }
            }
            if (groupsFilterDirty) {
                const g  = groupsFilterConfig;
                const og = originalGroupsFilterConfigRef.current;
                // 'topbar'/'sidebar' (modal) ↔ 'top'/'side' (backend).
                const wherefiltersToBackend = (v) => v === 'topbar' ? 'top' : 'side';
                // SIDE_FILTER_SLICE / SIDE_FILTER_STATES are JSON-coerced on
                // the mini-api end, so we send the JS object as-is in the
                // body's `value` slot — the mini-api JSON.stringify's it.
                // The JSON is replaced as a whole, so write every filter we
                // hold settings for (not only the active ones), under the
                // key the storefront reads (category1..7, not cat1..7). An
                // empty "items before more" is left out: the storefront then
                // shows all values, where '' would slice the list to nothing.
                const filterKeys = (cfg) => Array.from(new Set([...(cfg.activeFilters || []), ...Object.keys(cfg.filterSettings || {})]));
                const settingOf  = (cfg, fk) => cfg.filterSettings?.[fk] || DEFAULT_FILTER_SETTING;
                const sliceFromCfg  = (cfg) => Object.fromEntries(
                    filterKeys(cfg)
                        .map(fk => [sideFilterJsonKey(fk), settingOf(cfg, fk).itemsBeforeMore])
                        .filter(([, n]) => n !== '' && n != null)
                );
                const statesFromCfg = (cfg) => Object.fromEntries(
                    filterKeys(cfg).map(fk => [sideFilterJsonKey(fk), !!settingOf(cfg, fk).expandedByDefault])
                );
                const push = (key, current, original) => {
                    // For JSON values, stringify both sides for an honest
                    // compare; the patcher will re-encode anyway.
                    const c = typeof current  === 'object' ? JSON.stringify(current)  : String(current);
                    const o = typeof original === 'object' ? JSON.stringify(original) : String(original);
                    if (c !== o) {
                        patches.push({ kind: 'groups', path: `/admin/settings/${key}`, value: current });
                    }
                };
                // Reverse the load-time mapping for COLOR_FILTER_DISPLAY.
                const colorStyleToBackend = (v) =>
                    v === 'swatches' ? 'color' :
                    v === 'names'    ? 'text'  :
                    'color';
                push('FILTER_POSITION',          wherefiltersToBackend(g.layout.wherefilters), wherefiltersToBackend(og.layout.wherefilters));
                push('FILTER_SIZE_STYLE',        g.layout.sizeStyle,                            og.layout.sizeStyle);
                push('COLOR_FILTER_DISPLAY',     colorStyleToBackend(g.layout.colorStyle),      colorStyleToBackend(og.layout.colorStyle));
                push('FILTER_TOP_SPLIT_SIZES',   b(g.layout.splitWidthLength),                  b(og.layout.splitWidthLength));
                push('SIDE_FILTER_SHOW_COUNTERS',b(g.layout.showProductCount),                  b(og.layout.showProductCount));
                push('FILTER_HOVER_DISPLAY',     g.layout.hoverStyle,                           og.layout.hoverStyle);
                push('ORDER_SIDE_FILTER_BY',     g.sortFiltersBy || 'NAME',                     og.sortFiltersBy || 'NAME');
                push('FILTER_STYLE',             g.filterStyle || 'legacy',                     og.filterStyle || 'legacy');
                push('ORDER_NEWEST_FIELD',       newestFieldToSetting(g.newestSort),           newestFieldToSetting(og.newestSort));
                push('SIDE_FILTER_ORDER',        (g.activeFilters || []).join(','),             (og.activeFilters || []).join(','));
                // Always sent with this section, not only on a difference: an
                // earlier version stored these under the wrong keys (cat1 for
                // category1), and comparing form state with form state cannot
                // see that. Two small requests per filter save.
                patches.push({ kind: 'groups', path: '/admin/settings/SIDE_FILTER_SLICE',  value: sliceFromCfg(g) });
                patches.push({ kind: 'groups', path: '/admin/settings/SIDE_FILTER_STATES', value: statesFromCfg(g) });
                push('FILTER_TREE_LEVELS',       (g.mobileHierarchy || []).join(','),           (og.mobileHierarchy || []).join(','));
                push('EXPLORE_SORT_ORDER',       (g.sortOptions || []).join(','),               (og.sortOptions || []).join(','));
                push('EXPLORE_SORT_DEFAULT_RULE',sortRuleToCsv(g.defaultSortRule),              sortRuleToCsv(og.defaultSortRule));
            }
            if (globalWidthsDirty) {
                const w  = globalWidths;
                const ow = originalGlobalWidthsRef.current;
                const push = (key, current, original) => {
                    if (String(current) !== String(original)) {
                        patches.push({ kind: 'widths', path: `/admin/settings/${key}`, value: String(current) });
                    }
                };
                push('SHOP_MAX_WIDTH_COMPLETE',         b(w.applyToWholeSite),                b(ow.applyToWholeSite));
                push('SHOP_MAX_WIDTH',                  w.productPagesWidth,                  ow.productPagesWidth);
                // New-admin-only key — the mini-api PATCH creates the row on
                // first save (creatable whitelist).
                push('BUTTON_BORDER_RADIUS',            w.buttonBorderRadius,                 ow.buttonBorderRadius);
                push('SHOP_MAX_WIDTH_TOP',              w.perElement?.languageBar?.width,     ow.perElement?.languageBar?.width);
                push('SHOP_MAX_WIDTH_TOP_FW_BG',        b(w.perElement?.languageBar?.bgFullWidth), b(ow.perElement?.languageBar?.bgFullWidth));
                push('SHOP_MAX_WIDTH_HEADER',           w.perElement?.header?.width,          ow.perElement?.header?.width);
                push('SHOP_MAX_WIDTH_HEADER_FW_BG',     b(w.perElement?.header?.bgFullWidth), b(ow.perElement?.header?.bgFullWidth));
                push('SHOP_MAX_WIDTH_BANNERS',          w.perElement?.infoBannerBelow?.width, ow.perElement?.infoBannerBelow?.width);
                push('SHOP_MAX_WIDTH_BANNERS_FW_BG',    b(w.perElement?.infoBannerBelow?.bgFullWidth), b(ow.perElement?.infoBannerBelow?.bgFullWidth));
                push('SHOP_MAX_WIDTH_BANNERS_TOP',      w.perElement?.infoBannerTop?.width,   ow.perElement?.infoBannerTop?.width);
                push('SHOP_MAX_WIDTH_BANNERS_TOP_FW_BG',b(w.perElement?.infoBannerTop?.bgFullWidth), b(ow.perElement?.infoBannerTop?.bgFullWidth));
                push('SHOP_MAX_WIDTH_BRANDS',           w.perElement?.brands?.width,          ow.perElement?.brands?.width);
                push('SHOP_MAX_WIDTH_EXPLORE',          w.perElement?.explore?.width,         ow.perElement?.explore?.width);
                push('SHOP_MAX_WIDTH_RECENT',           w.perElement?.recentlyViewed?.width,  ow.perElement?.recentlyViewed?.width);
                push('SHOP_MAX_WIDTH_RECENT_FW_BG',     b(w.perElement?.recentlyViewed?.bgFullWidth), b(ow.perElement?.recentlyViewed?.bgFullWidth));
                push('SHOP_MAX_WIDTH_FOOTER',           w.perElement?.footer?.width,          ow.perElement?.footer?.width);
                push('SHOP_MAX_WIDTH_FOOTER_FW_BG',     b(w.perElement?.footer?.bgFullWidth), b(ow.perElement?.footer?.bgFullWidth));
            }
            if (headerLogoDirty) {
                const cur  = headerLogoConfig.size?.logoBarHeight;
                const orig = originalHeaderLogoConfigRef.current.size?.logoBarHeight;
                if (String(cur) !== String(orig)) {
                    patches.push({ kind: 'header-logo', path: '/admin/settings/HEADER_HEIGHT', value: String(cur) });
                }
            }
            if (navigationDirty) {
                const n  = navigationConfig;
                const on = originalNavigationConfigRef.current;
                const push = (key, current, original) => {
                    if (String(current) !== String(original)) {
                        patches.push({ kind: 'nav', path: `/admin/settings/${key}`, value: String(current) });
                    }
                };
                // headerContent toggles
                push('SHOW_HEADER_ABOUTUS', b(n.headerContent.contact),      b(on.headerContent.contact));
                push('SHOW_HEADER_BRANDS',  b(n.headerContent.brands),       b(on.headerContent.brands));
                push('SHOW_HEADER_LOOKS',   b(n.headerContent.shopTheLook),  b(on.headerContent.shopTheLook));
                push('SHOW_SALES_BUTTON',   b(n.headerContent.outlet),       b(on.headerContent.outlet));
                push('SHOW_HEADER_SEARCH',  b(n.headerContent.search),       b(on.headerContent.search));
                push('SHOW_HEADER_ACCOUNT', b(n.headerContent.account),      b(on.headerContent.account));
                push('SHOW_HEADER_CART',    b(n.headerContent.cart),         b(on.headerContent.cart));
                push('SHOW_HEADER_CHEQUES', b(n.headerContent.giftVoucher),  b(on.headerContent.giftVoucher));
                push('HOME_ENABLED',        b(n.headerContent.showHomeButton), b(on.headerContent.showHomeButton));
                push('HOME_URL',            n.headerContent.homeUrl || '',    on.headerContent.homeUrl || '');
                push('DEFAULT_SEARCH_STATE_VISIBLE', b(n.headerContent.searchExpandedByDefault), b(on.headerContent.searchExpandedByDefault));
                // outletMode
                push('MIN_DISCOUNT_FOR_SALES',  n.outletMode.minDiscount,      on.outletMode.minDiscount);
                push('HIDE_SALES_FROM_EXPLORE', b(n.outletMode.hideFromExplore), b(on.outletMode.hideFromExplore));
                // layout
                push('HEADER_TYPE',                  n.layout.menuStyle,                    on.layout.menuStyle);
                push('HEADER_ACCOUNT_POSITION',      n.layout.actionButtonsPosition,        on.layout.actionButtonsPosition);
                push('CENTER_HEADER',                b(n.layout.centerTopHeaderButtons),   b(on.layout.centerTopHeaderButtons));
                push('CENTER_LOGO',                  b(n.layout.centerTopButtonInMiddle),  b(on.layout.centerTopButtonInMiddle));
                push('HEADER_FILTER_SPACE_ACTIONS',  b(n.layout.alignActionButtonsRight),  b(on.layout.alignActionButtonsRight));
                // navigationMenu — legacy NAVBAR_ITEMS_TO_LIST is a single
                // string '0'-'7'. Modal stores categoriesShown as an array,
                // so we serialise the first element (or '0' for "none").
                const navbarCat = (n.navigationMenu.categoriesShown && n.navigationMenu.categoriesShown[0]) || '0';
                const navbarCatOrig = (on.navigationMenu.categoriesShown && on.navigationMenu.categoriesShown[0]) || '0';
                push('NAVBAR_ITEMS_TO_LIST',     navbarCat,                       navbarCatOrig);
                push('HEADER_ITEM_BREAK_AMOUNT', n.navigationMenu.itemsPerRow,    on.navigationMenu.itemsPerRow);
                push('HEADER_FILTER_HEIGHT',     n.navigationMenu.menuHeight,     on.navigationMenu.menuHeight);
                push('HEADER_FILTER_FONT_SIZE',  n.navigationMenu.menuTextSize,   on.navigationMenu.menuTextSize);
                push('HEADER_FILTER_UPPERCASE',  b(n.navigationMenu.uppercaseMenu), b(on.navigationMenu.uppercaseMenu));
                // behaviour
                push('SHOW_HEADER_FILTER_ON_SCROLL', b(n.behaviour.keepMenuVisibleWhileScrolling), b(on.behaviour.keepMenuVisibleWhileScrolling));
            }
            // Navbar filter order — PATCH /admin/navbar-order/{categoryId} per
            // row whose order_index changed (category ids are strings, e.g. '0301').
            const navbarOrderOps = [];
            if (navbarOrderDirty) {
                const origById = Object.fromEntries(originalNavbarOrderRef.current.map(r => [r.id, r]));
                for (const r of navbarOrder) {
                    const o = origById[r.id];
                    if (!o || Number(r.order_index) !== Number(o.order_index)) {
                        navbarOrderOps.push({
                            kind:   'navbar-order',
                            method: 'PATCH',
                            path:   `/admin/navbar-order/${r.id}`,
                            body:   { order_index: Number(r.order_index) || 0 },
                        });
                    }
                }
            }
            if (footerDirty) {
                const f  = footerConfig;
                const of = originalFooterConfigRef.current;
                const push = (key, current, original) => {
                    if (String(current) !== String(original)) {
                        patches.push({ kind: 'footer', path: `/admin/settings/${key}`, value: String(current) });
                    }
                };
                push('SHOW_NEWSLETTER',              b(f.newsletter.enabled),                b(of.newsletter.enabled));
                push('NEWSLETTER_POPUP',             b(f.newsletter.showInPopup),            b(of.newsletter.showInPopup));
                push('NEWSLETTER_POPUP_FIRST_VISIT', b(f.newsletter.openPopupAutomatically), b(of.newsletter.openPopupAutomatically));
                // Per-page external link overrides.
                push('SF_LINK_ABOUT',      f.pages?.about      ?? '', of.pages?.about      ?? '');
                push('SF_LINK_TERMS',      f.pages?.terms      ?? '', of.pages?.terms      ?? '');
                push('SF_LINK_PRIVACY',    f.pages?.privacy    ?? '', of.pages?.privacy    ?? '');
                push('SF_LINK_DISCLAIMER', f.pages?.disclaimer ?? '', of.pages?.disclaimer ?? '');
                // Contact info.
                push('SF_INFO_NAME',    f.contact?.shopName    ?? '', of.contact?.shopName    ?? '');
                push('SF_PAGE_TITLE_SUFFIX', f.contact?.titleSuffix ?? '', of.contact?.titleSuffix ?? '');
                push('SF_INFO_ADDRESS', f.contact?.addressLine ?? '', of.contact?.addressLine ?? '');
                push('SF_INFO_CITY',    f.contact?.city        ?? '', of.contact?.city        ?? '');
                push('SF_INFO_VAT',     f.contact?.vatNumber   ?? '', of.contact?.vatNumber   ?? '');
                push('SF_INFO_PHONE',   f.contact?.phone       ?? '', of.contact?.phone       ?? '');
                push('SF_INFO_EMAIL',   f.contact?.email       ?? '', of.contact?.email       ?? '');
                push('SF_INFO_WEBSITE', f.contact?.website     ?? '', of.contact?.website     ?? '');
                push('SF_INFO_ADDRESS_GEO', formatAddressGeo(f.contact?.geoLat, f.contact?.geoLng), formatAddressGeo(of.contact?.geoLat, of.contact?.geoLng));
            }

            // External-links CRUD (footer custom links + social media). They
            // share an endpoint and only differ by the `position` column.
            // Pattern mirrors carousel/image-grid: POST for missing serverIds,
            // PATCH for changed rows, DELETE for rows dropped from the list.
            const externalLinkOps = [];
            if (footerDirty) {
                const buildOps = (currentList, originalList, position, labelMode) => {
                    const origById = new Map(
                        originalList.filter(l => l.serverId != null).map(l => [l.serverId, l])
                    );
                    const currentIds = new Set(
                        currentList.map(l => l.serverId).filter(id => id != null)
                    );

                    for (const l of currentList) {
                        const body = {
                            // Label-mode rows (custom links) carry their OWN
                            // placement — forcing the group position here used
                            // to silently move header links into the footer.
                            position: labelMode ? ((l.position || 'FOOTER').toUpperCase()) : position,
                            ...(labelMode ? { header_position: (l.headerPosition || 'EXTRA').toUpperCase(), target: l.target || 'default' } : {}),
                            url:    l.url || '',
                            loc_nl: labelMode ? (l.labels?.nl || '') : null,
                            loc_en: labelMode ? (l.labels?.en || '') : null,
                            loc_fr: labelMode ? (l.labels?.fr || '') : null,
                        };
                        if (l.serverId == null) {
                            externalLinkOps.push({
                                kind:   'extlink-create',
                                crud:   { type: 'create', row: l },
                                method: 'POST',
                                path:   '/admin/external-links',
                                body,
                            });
                            continue;
                        }
                        const o = origById.get(l.serverId);
                        if (!o) continue;
                        const changed = (
                            (l.url || '') !== (o.url || '') ||
                            (labelMode && (
                                (l.labels?.nl || '') !== (o.labels?.nl || '') ||
                                (l.labels?.en || '') !== (o.labels?.en || '') ||
                                (l.labels?.fr || '') !== (o.labels?.fr || '') ||
                                (l.position || 'FOOTER') !== (o.position || 'FOOTER') ||
                                (l.headerPosition || 'EXTRA') !== (o.headerPosition || 'EXTRA') ||
                                (l.target || 'default') !== (o.target || 'default')
                            ))
                        );
                        if (changed) {
                            externalLinkOps.push({
                                kind:   'extlink-update',
                                crud:   { type: 'update', row: l },
                                method: 'PATCH',
                                path:   `/admin/external-links/${l.serverId}`,
                                body,
                            });
                        }
                    }
                    for (const o of originalList) {
                        if (o.serverId != null && !currentIds.has(o.serverId)) {
                            externalLinkOps.push({
                                kind:   'extlink-delete',
                                crud:   { type: 'delete', id: o.serverId },
                                method: 'DELETE',
                                path:   `/admin/external-links/${o.serverId}`,
                                body:   null,
                            });
                        }
                    }
                };
                buildOps(footerConfig.customLinks || [], originalFooterConfigRef.current.customLinks || [], 'FOOTER', true);
                buildOps(footerConfig.socialMedia || [], originalFooterConfigRef.current.socialMedia || [], 'SOCIAL', false);
            }
            if (extraFooterDirty) {
                const e  = extraFooterConfig;
                const oe = originalExtraFooterConfigRef.current;
                if (b(e.showPaymentMethods) !== b(oe.showPaymentMethods)) {
                    patches.push({
                        kind:  'extra-footer',
                        path:  '/admin/settings/FOOTER_EXTRA_PAYMENT_METHODS',
                        value: b(e.showPaymentMethods),
                    });
                }
                // Per-column content — PATCH /admin/contents/TEXT_FOOTER_COL_N.
                // The endpoint accepts the same body shape for both editors:
                //   wysiwyg: body_nl/en/fr as strings,  is_via_file=false
                //   unlayer: body_nl/en/fr as { html, design } objects,
                //            is_via_file=true (the server writes both .html
                //            and .json to statics/content/{attr}/{lang}.*)
                for (const colIdx of [1, 2, 3]) {
                    const cur  = e.columns?.[colIdx]  || blankColumn();
                    const orig = oe.columns?.[colIdx] || blankColumn();
                    const htmlChanged =
                        (cur.html?.nl || '') !== (orig.html?.nl || '') ||
                        (cur.html?.en || '') !== (orig.html?.en || '') ||
                        (cur.html?.fr || '') !== (orig.html?.fr || '');
                    // Unlayer edits land in `design` before they hit the
                    // rendered HTML, so an html-only diff would miss them.
                    const designChanged =
                        JSON.stringify(cur.design?.nl ?? null) !== JSON.stringify(orig.design?.nl ?? null) ||
                        JSON.stringify(cur.design?.en ?? null) !== JSON.stringify(orig.design?.en ?? null) ||
                        JSON.stringify(cur.design?.fr ?? null) !== JSON.stringify(orig.design?.fr ?? null);
                    // Mode switch alone (unlayer → wysiwyg) needs to fire
                    // so the server deletes the design sidecars.
                    const editorChanged = (cur.editor || 'wysiwyg') !== (orig.editor || 'wysiwyg');
                    if (!htmlChanged && !designChanged && !editorChanged) continue;

                    // Designer and own HTML live in the {lang}.html files, text
                    // in the table. Own HTML never writes a design sidecar.
                    const editor = cur.editor || 'wysiwyg';
                    const inFiles = editor !== 'wysiwyg';
                    // PATCH body matches mini-api `/admin/contents/{attr}` shape.
                    // Custom-channel ops can ride alongside /admin/settings
                    // PATCHes because we render them through the same
                    // `path: ...` mechanism below — value is JSON-coerced
                    // server-side same as JSON_KEYS settings.
                    patches.push({
                        kind:  'extra-footer-content',
                        path:  `/admin/contents/TEXT_FOOTER_COL_${colIdx}`,
                        // The body field is the FULL PATCH body, not wrapped
                        // in a `value` key. We flag that so the Promise.all
                        // mapper below sends the right shape.
                        rawBody: {
                            // only the edited languages (contentBodiesToSend)
                            ...contentBodiesToSend(cur, orig, inFiles, editor === 'unlayer' ? 'design' : null),
                            is_via_file:    inFiles,
                            is_custom_html: editor === 'html',
                            // use_iframe stays at whatever the row already
                            // had — the modal doesn't surface it.
                        },
                    });
                }
            }
            if (staticPagesDirty) {
                // About / Disclaimer / Privacy → contents rows. Same PATCH
                // shape as the Extra footer columns: a wysiwyg body is a
                // plain string; an unlayer body is a { html, design } object
                // and rides is_via_file=true so the server writes the .html +
                // .json sidecars. use_iframe round-trips the page's toggle.
                const attrFor = { about: 'TEXT_ABOUT', disclaimer: 'TEXT_DISCLAIMER', privacy: 'TEXT_PRIVACY', page404: 'TEXT_404', intro: 'TEXT_INTRO', detail: 'TEXT_DETAIL', cheques: 'TEXT_CHEQUES' };
                for (const key of ['about', 'disclaimer', 'privacy', 'page404', 'intro', 'detail', 'cheques']) {
                    const cur  = staticPages[key]                       || STATIC_PAGE_DEFAULT;
                    const orig = originalStaticPagesRef.current[key]    || STATIC_PAGE_DEFAULT;
                    if (JSON.stringify(cur) === JSON.stringify(orig)) continue;
                    // Designer and own HTML live in the {lang}.html files, text
                    // in the table. Own HTML never writes a design sidecar.
                    const editor = cur.editor || 'wysiwyg';
                    const inFiles = editor !== 'wysiwyg';
                    patches.push({
                        kind:  'static-page-content',
                        path:  `/admin/contents/${attrFor[key]}`,
                        rawBody: {
                            // only the edited languages (contentBodiesToSend)
                            ...contentBodiesToSend(cur, orig, inFiles, editor === 'unlayer' ? 'designs' : null),
                            is_via_file:    inFiles,
                            is_custom_html: editor === 'html',
                            use_iframe:     !!cur.iframe,
                        },
                    });
                }
            }
            if (cardsDirty) {
                // Cart-page account cards → contents rows (wysiwyg, so body is a
                // plain string and is_via_file=false). Only the changed cards.
                const origById = Object.fromEntries(originalCardsRef.current.map(c => [c.id, c]));
                for (const card of cards) {
                    const meta = CARD_CONTENT[card.id];
                    if (!meta) continue;
                    const orig = origById[card.id];
                    const changed = !orig
                        || card.contentNL !== orig.contentNL
                        || card.contentEN !== orig.contentEN
                        || card.contentFR !== orig.contentFR
                        || !!card.useIframe !== !!orig.useIframe;
                    if (!changed) continue;
                    patches.push({
                        kind:  'card-content',
                        path:  `/admin/contents/${meta.attr}`,
                        rawBody: {
                            body_nl:     card.contentNL || '',
                            body_en:     card.contentEN || '',
                            body_fr:     card.contentFR || '',
                            is_via_file: false,
                            use_iframe:  !!card.useIframe,
                        },
                    });
                }
                // Cart page layout — CART_DISPLAY_INFO / CART_SECTIONS_ORDER.
                const cl = cartLayout, ocl = originalCartLayoutRef && originalCartLayoutRef.current;
                if (cl && ocl) {
                    const info  = cartDisplayInfoToSetting(cl.lines.map(serializeChipsToTemplate), cl.extra);
                    const oinfo = cartDisplayInfoToSetting(ocl.lines.map(serializeChipsToTemplate), ocl.extra);
                    if (info !== oinfo) patches.push({ kind: 'card-setting', path: '/admin/settings/CART_DISPLAY_INFO', value: info });
                    const order = cl.sections.join(','), oorder = ocl.sections.join(',');
                    if (order !== oorder) patches.push({ kind: 'card-setting', path: '/admin/settings/CART_SECTIONS_ORDER', value: order });
                }
            }
            if (brandsConfigDirty) {
                const b = brandsConfig, ob = originalBrandsConfigRef.current;
                // Flat keys.
                if (!!b.whatToShow.onlyOnline !== !!ob.whatToShow.onlyOnline) {
                    patches.push({ kind: 'brands', path: '/admin/settings/BRANDS_ONLY_ONLINE', value: b.whatToShow.onlyOnline ? '1' : '0' });
                }
                const catCur  = b.whatToShow.navigationCategory  || 'none';
                const catOrig = ob.whatToShow.navigationCategory || 'none';
                if (catCur !== catOrig) {
                    patches.push({ kind: 'brands', path: '/admin/settings/BRANDS_CATEGORY_FILTER', value: catCur });
                }
                if (b.layout !== ob.layout) {
                    patches.push({ kind: 'brands', path: '/admin/settings/BRANDS_PAGE_STYLE', value: BRANDS_LAYOUT_TO_STYLE[b.layout] || 'list' });
                }
                // BRANDS_PAGE_CONFIG JSON blob — only when a JSON-backed field
                // changed. Merge over the raw loaded blob to keep keys the tab
                // doesn't surface (idx, divider, moreLabel, …). Passed as an
                // object; the mini-api JSON-encodes it server-side.
                const jsonRelevant = (c) => JSON.stringify({ settings: c.settings, textStyles: c.textStyles });
                if (jsonRelevant(b) !== jsonRelevant(ob)) {
                    const toShort = (st) => ({ s: st.size, b: !!st.bold, i: !!st.italic, u: !!st.underline, c: st.color });
                    patches.push({
                        kind:  'brands-json',
                        path:  '/admin/settings/BRANDS_PAGE_CONFIG',
                        value: {
                            ...originalBrandsRawJsonRef.current,
                            lm:   b.settings.displayContinuous,
                            am:   b.settings.displayGrouped,
                            cols: Number(b.settings.letterColumns) || 4,
                            max:  Number(b.settings.brandsPerLetter) || 0,
                            sul:  !!b.settings.showLettersWithoutBrands,
                            d: { bn: toShort(b.textStyles.desktop.brandName), ai: toShort(b.textStyles.desktop.alphabetNav), al: toShort(b.textStyles.desktop.letterHeading) },
                            m: { bn: toShort(b.textStyles.mobile.brandName),  ai: toShort(b.textStyles.mobile.alphabetNav),  al: toShort(b.textStyles.mobile.letterHeading) },
                        },
                    });
                }
            }
            // Overige — custom scripts (POST per changed section) + GTM/Pixel
            // (settings PATCH + generate-file POST). Custom-scripts & generate
            // calls have their own bodies so they ride a dedicated ops list.
            const overigeOps = [];
            if (overigeConfigDirty) {
                const oc = overigeConfig, ooc = originalOverigeConfigRef.current;
                // Custom code → _scriptsHeader.php / _scriptsBody.php.
                if ((oc.customCode?.head || '') !== (ooc.customCode?.head || '')) {
                    overigeOps.push({ kind: 'scripts-head', method: 'POST', path: '/admin/custom-scripts', body: { content: oc.customCode?.head || '', section: 'head' } });
                }
                if ((oc.customCode?.body || '') !== (ooc.customCode?.body || '')) {
                    overigeOps.push({ kind: 'scripts-body', method: 'POST', path: '/admin/custom-scripts', body: { content: oc.customCode?.body || '', section: 'body' } });
                }
                // Tracking tools — ONE call that persists all 5 tool IDs +
                // active flags AND regenerates the SFT-TRACKING block inside
                // _scriptsHeader/_scriptsBody (the snippets the storefront
                // actually renders). Replaces the old generate-gtm/pixel pair
                // that only wrote inc.*.id side-files nothing rendered from.
                const toolsJson = (c) => JSON.stringify((c.trackingTools || []).map(t => ({ key: t.key, id: t.id || '', active: !!t.active, category: t.category || '' })).sort((a, b) => a.key.localeCompare(b.key)));
                if (toolsJson(oc) !== toolsJson(ooc)) {
                    overigeOps.push({
                        kind:   'tracking-tools',
                        method: 'POST',
                        path:   '/admin/tracking-tools',
                        body:   { tools: (oc.trackingTools || []).map(t => ({ key: t.key, id: t.id || '', active: !!t.active, category: t.category || '' })) },
                    });
                }
                // E-commerce events (mig215) → two plain settings.
                const te = oc.trackingEvents || {}, ote = ooc.trackingEvents || {};
                const metaEvents = te.metaEvents === 'gtm' ? 'gtm' : 'webshop';
                if (metaEvents !== (ote.metaEvents === 'gtm' ? 'gtm' : 'webshop')) {
                    patches.push({ kind: 'tracking-events', path: '/admin/settings/TRACKING_META_EVENTS', value: metaEvents });
                }
                if (!!te.ga4ItemsArray !== !!ote.ga4ItemsArray) {
                    patches.push({ kind: 'tracking-events', path: '/admin/settings/TRACKING_GA4_ITEMS_ARRAY', value: te.ga4ItemsArray ? '1' : '0' });
                }
                // Cookie banner → cookie.js (the route merges onto the existing
                // config so per-language translations are preserved).
                const cc = oc.cookies || {}, occ = ooc.cookies || {};
                // the on/off switch rides on the same request: the save sends
                // its requests in parallel, and the route switches first, then
                // writes the settings into the right file
                const cookiesEnabledChanged = cc.enabled !== undefined && !!cc.enabled !== !!(occ.enabled ?? true);
                const cookiesChanged = cookiesEnabledChanged || cc.bannerStyle !== occ.bannerStyle
                    || cc.position !== occ.position
                    || !!cc.categories?.analytics !== !!occ.categories?.analytics
                    || !!cc.categories?.marketing !== !!occ.categories?.marketing
                    || !!cc.categories?.personalization !== !!occ.categories?.personalization;
                if (cookiesChanged) {
                    overigeOps.push({
                        kind: 'cookie-consent', method: 'POST', path: '/admin/cookie-consent',
                        body: {
                            layout:    OVERIGE_STYLE_TO_LAYOUT[cc.bannerStyle] || 'box',
                            position:  cc.position || 'bottom right',
                            analytics: !!cc.categories?.analytics,
                            marketing: !!cc.categories?.marketing,
                            personalization: !!cc.categories?.personalization,
                            ...(cookiesEnabledChanged ? { enabled: !!cc.enabled } : {}),
                        },
                    });
                }
            }

            // Cadeaubon settings — diff the flat CHEQUES_* map and PATCH only the
            // keys that changed (same value shape the backend stores).
            if (cadeaubonConfigDirty) {
                const curChq  = cadeaubonToSettings(cadeaubonConfig);
                const origChq = cadeaubonToSettings(originalCadeaubonConfigRef.current);
                for (const key of Object.keys(curChq)) {
                    if (curChq[key] !== origChq[key]) {
                        patches.push({ kind: 'cadeaubon', path: `/admin/settings/${key}`, value: curChq[key] });
                    }
                }
            }

            // Cadeaubon translations (cheques_placeholders CRUD). New rows (no id)
            // POST — the backend generates the PLC_* key from the description;
            // existing rows PATCH only layout/loc_*; removed rows DELETE.
            const cadeaubonOps = [];
            if (cadeaubonPlaceholdersDirty) {
                const origPlc     = originalPlaceholdersRef.current;
                const origPlcById = Object.fromEntries(origPlc.filter(p => p.id != null).map(p => [p.id, p]));
                const curPlcIds   = new Set(cadeaubonPlaceholders.filter(p => p.id != null).map(p => p.id));
                for (const op of origPlc) {
                    if (op.id != null && !curPlcIds.has(op.id)) {
                        cadeaubonOps.push({ kind: 'plc-del', crud: { type: 'delete', id: op.id }, method: 'DELETE', path: `/cheque-placeholders/${op.id}`, body: {} });
                    }
                }
                for (const p of cadeaubonPlaceholders) {
                    if (p.id == null) {
                        if (!(p.description || '').trim()) continue; // skip empty new rows
                        cadeaubonOps.push({ kind: 'plc-new', crud: { type: 'create', row: p }, method: 'POST', path: '/cheque-placeholders', body: {
                            description: p.description, layout: p.layout || 'GLOBAL',
                            loc_nl: p.nl || '', loc_en: p.en || '', loc_fr: p.fr || '',
                        } });
                    } else {
                        const o = origPlcById[p.id];
                        const changed = !o || o.nl !== p.nl || o.en !== p.en || o.fr !== p.fr || (o.layout || '') !== (p.layout || '');
                        if (changed) {
                            cadeaubonOps.push({ kind: 'plc-upd', crud: { type: 'update', row: p }, method: 'PATCH', path: `/cheque-placeholders/${p.id}`, body: {
                                layout: p.layout || 'GLOBAL', loc_nl: p.nl || '', loc_en: p.en || '', loc_fr: p.fr || '',
                            } });
                        }
                    }
                }
            }

            // Cadeaubon voucher layouts (cheques_layouts CRUD). New rows (no
            // serverId) POST — with an optional copy_layout_from to clone a
            // system default; existing rows PATCH type/description/visible;
            // removed non-system rows DELETE. Image + design uploads run AFTER
            // (they need the fresh id), mapped via layoutRef. System defaults
            // (isSystem) are never POST/DELETE'd.
            const cadeaubonLayoutOps = [];
            if (cadeaubonLayoutsDirty) {
                const origLay     = originalCadeaubonLayoutsRef.current;
                const origLayById = Object.fromEntries(origLay.filter(l => l.serverId != null).map(l => [l.serverId, l]));
                const curLayIds   = new Set(cadeaubonLayouts.filter(l => l.serverId != null).map(l => l.serverId));
                for (const o of origLay) {
                    if (o.serverId != null && !o.isSystem && !curLayIds.has(o.serverId)) {
                        cadeaubonLayoutOps.push({ kind: 'lay-del', crud: { type: 'delete', id: o.serverId }, method: 'DELETE', path: `/cheques-layouts/${o.serverId}`, body: {} });
                    }
                }
                for (const l of cadeaubonLayouts) {
                    if (l.serverId == null) {
                        cadeaubonLayoutOps.push({
                            kind: 'lay-new', method: 'POST', path: '/cheques-layouts',
                            crud: { type: 'create', row: l },
                            layoutRef: { tempId: l.id },
                            body: {
                                type:        l.type,
                                description: l.description || '',
                                visible:     l.visible ? 1 : 0,
                                ...(l.copyFrom != null ? { copy_layout_from: l.copyFrom } : {}),
                            },
                        });
                    } else if (!l.isSystem) {
                        const o = origLayById[l.serverId];
                        const changed = !o || o.type !== l.type || (o.description || '') !== (l.description || '') || !!o.visible !== !!l.visible;
                        if (changed) {
                            cadeaubonLayoutOps.push({
                                kind: 'lay-upd', method: 'PATCH', path: `/cheques-layouts/${l.serverId}`,
                                crud: { type: 'update', row: l },
                                body: { type: l.type, description: l.description || '', visible: l.visible ? 1 : 0 },
                            });
                        }
                    }
                }
            }

            // Verwerking — scalar settings diff + the 3 CHEQUES_* discount JSON.
            if (processingConfigDirty) {
                const curProc  = processingToSettings(processingConfig);
                const origProc = processingToSettings(originalProcessingConfigRef.current);
                // Validate a changed guest customer id; an invalid one is left out
                // of the save (everything else still saves).
                const curGuest  = String(processingConfig.access?.guestCustomerId ?? '').trim();
                const origGuest = String(originalProcessingConfigRef.current.access?.guestCustomerId ?? '').trim();
                if (curGuest && curGuest !== origGuest && typeof validateCustomerId === 'function') {
                    const guestRes = await validateCustomerId(curGuest);
                    if (guestRes && guestRes.status === 'invalid') guestIdSkipped = true;
                }
                for (const key of Object.keys(curProc)) {
                    if (key.startsWith('__')) continue;                              // dirty-only signal
                    if (key === 'PROCESS_PAYMENT_METHODS' && curProc[key] === 'NOCHECKOUT') continue; // pending option, don't write
                    if (key === 'PROCESS_NO_ACCOUNT_ID' && guestIdSkipped) continue; // invalid id — don't persist
                    if (curProc[key] !== origProc[key]) {
                        patches.push({ kind: 'processing', path: `/admin/settings/${key}`, value: curProc[key] });
                    }
                }
                // Discount/voucher JSON — rebuild over the originals so codes not
                // shown in the UI rows are preserved, then patch the ones that changed.
                const orig = originalProcChequeRef.current;
                const buildObj = (base, field) => {
                    const out = { ...(base || {}) };
                    Object.keys(processingConfig.discountTypes || {}).forEach((code6) => {
                        out[`99${code6}`] = !!(processingConfig.discountTypes[code6] || {})[field];
                    });
                    return out;
                };
                const nextAllowed = buildObj(orig.allowed,      'enabled');
                const nextAsPay   = buildObj(orig.asPayment,    'acceptAsPayment');
                const nextReceipt = buildObj(orig.addToReceipt, 'showInEmail');
                if (JSON.stringify(nextAllowed) !== JSON.stringify(orig.allowed))      patches.push({ kind: 'processing', path: '/admin/settings/CHEQUES_ALLOWED',        value: nextAllowed });
                if (JSON.stringify(nextAsPay)   !== JSON.stringify(orig.asPayment))    patches.push({ kind: 'processing', path: '/admin/settings/CHEQUES_AS_PAYMENT',     value: nextAsPay });
                if (JSON.stringify(nextReceipt) !== JSON.stringify(orig.addToReceipt)) patches.push({ kind: 'processing', path: '/admin/settings/CHEQUES_ADD_TO_RECEIPT', value: nextReceipt });

                // "No checkout" ↔ PROCESS_TICKET_MODULE LOOKBOOK. Switching back to a
                // checkout location re-enables ordering (RESERVATION), preserving an
                // existing RESERVATION/RECEIPT mode otherwise.
                const procLoc    = processingConfig.payments?.location;
                const origModule = originalTicketModuleRef.current;
                const nextModule = (procLoc === 'noCheckout') ? 'LOOKBOOK' : (origModule === 'LOOKBOOK' ? 'RESERVATION' : origModule);
                if (nextModule && nextModule !== origModule) {
                    patches.push({ kind: 'processing', path: '/admin/settings/PROCESS_TICKET_MODULE', value: nextModule });
                }
            }

            // Synchronisatie — scalar settings diff (FETCH_*, MAP_*, PHOTO_*).
            if (syncConfigDirty) {
                const curSync  = syncToSettings(syncConfig, allStoreCodesForSync);
                const origSync = syncToSettings(originalSyncConfigRef.current, allStoreCodesForSync);
                for (const key of Object.keys(curSync)) {
                    if (curSync[key] !== origSync[key]) {
                        patches.push({ kind: 'sync', path: `/admin/settings/${key}`, value: curSync[key] });
                    }
                }
            }

            // Custom customer fields — customers_categories_groups CRUD. New rows
            // (no id) POST; existing rows PATCH changed columns; removed rows DELETE.
            const customerGroupOps = [];
            if (customerGroupsDirty) {
                const origGroups     = originalCustomerGroupsRef.current;
                const origGroupsById = Object.fromEntries(origGroups.filter(g => g.id != null).map(g => [g.id, g]));
                const curGroupIds    = new Set(customerCategoryGroups.filter(g => g.id != null).map(g => g.id));
                for (const og of origGroups) {
                    if (og.id != null && !curGroupIds.has(og.id)) {
                        customerGroupOps.push({ kind: 'ccg-del', crud: { type: 'delete', id: og.id }, method: 'DELETE', path: `/admin/customer-category-groups/${og.id}`, body: {} });
                    }
                }
                for (const g of customerCategoryGroups) {
                    const cols = customerGroupToColumns(g);
                    if (g.id == null) {
                        if (!cols.sft_id) continue; // skip new rows without a code group
                        customerGroupOps.push({ kind: 'ccg-new', crud: { type: 'create', row: g }, method: 'POST', path: '/admin/customer-category-groups', body: cols });
                    } else {
                        const o = origGroupsById[g.id];
                        const origCols = o ? customerGroupToColumns(o) : null;
                        const body = {};
                        for (const c of Object.keys(cols)) {
                            if (!origCols || JSON.stringify(cols[c]) !== JSON.stringify(origCols[c])) body[c] = cols[c];
                        }
                        if (Object.keys(body).length) {
                            customerGroupOps.push({ kind: 'ccg-upd', crud: { type: 'update', row: g }, method: 'PATCH', path: `/admin/customer-category-groups/${g.id}`, body });
                        }
                    }
                }
            }

            if (looksConfigDirty) {
                const l = looksConfig, ol = originalLooksConfigRef.current;
                const push = (key, current, original) => {
                    if (String(current) !== String(original)) {
                        patches.push({ kind: 'looks', path: `/admin/settings/${key}`, value: String(current) });
                    }
                };
                const b01 = (v) => (v ? '1' : '0');
                // Grid
                push('LOOKS_NAVIGATION_CODE', l.looksGrid.navigationCategory, ol.looksGrid.navigationCategory);
                push('LOOKS_LIST_SORTING',    l.looksGrid.displayOrder,       ol.looksGrid.displayOrder);
                push('MAX_COLUMNS_LOOKS',     l.looksGrid.looksPerRow,        ol.looksGrid.looksPerRow);
                // Overlay
                push('LOOKS_OVERLAY_ONLY_ON_HOVER', b01(l.overlay.onlyOnHover),  b01(ol.overlay.onlyOnHover));
                push('LOOKS_OVERLAY_BGC',           l.overlay.bandBg,            ol.overlay.bandBg);
                push('LOOKS_OVERLAY_SIZE',          l.overlay.bandHeightPct,     ol.overlay.bandHeightPct);
                push('LOOKS_OVERLAY_POSITION',      l.overlay.bandVerticalPosition, ol.overlay.bandVerticalPosition);
                push('LOOKS_OVERLAY_SHOW_TITLE',    b01(l.overlay.showTitle),    b01(ol.overlay.showTitle));
                push('LOOKS_OVERLAY_FGC',           l.overlay.titleColor,        ol.overlay.titleColor);
                push('LOOKS_OVERLAY_TITLE_FS',      l.overlay.titleFontSize,     ol.overlay.titleFontSize);
                push('LOOKS_OVERLAY_SHOW_BUTTON',   b01(l.overlay.showCta),      b01(ol.overlay.showCta));
                push('LOOKS_OVERLAY_BUTTON_BGC',    l.overlay.ctaBg,             ol.overlay.ctaBg);
                push('LOOKS_OVERLAY_BUTTON_FGC',    l.overlay.ctaTextColor,      ol.overlay.ctaTextColor);
                push('LOOKS_OVERLAY_BUTTON_FS',     l.overlay.ctaFontSize,       ol.overlay.ctaFontSize);
                // Detail page
                push('LOOKS_DETAIL_TEXT_LOCATION', l.detailPage.descriptionPosition, ol.detailPage.descriptionPosition);
                push('LOOK_SHOW_DIVIDER',          b01(l.detailPage.showDividerBetweenProducts), b01(ol.detailPage.showDividerBetweenProducts));
                push('LOOK_SHOW_OUT_OF_STOCK',     b01(l.detailPage.showOutOfStock),             b01(ol.detailPage.showOutOfStock));
                // Product title/subtitle — space-separated field tokens.
                push('SHOW_FIELDS_ON_LOOK_TITLE',      serializeChipsToTemplate(l.productTitle),    serializeChipsToTemplate(ol.productTitle));
                push('SHOW_FIELDS_ON_LOOK_SUBHEADING', serializeChipsToTemplate(l.productSubtitle), serializeChipsToTemplate(ol.productSubtitle));
                // Intro text + iframe flag → TEXT_LOOKS content row (wysiwyg,
                // plain strings). The "Show in iframe" toggle is this content
                // row's use_iframe (the looks page renders it via content-display).
                if (JSON.stringify(l.introText) !== JSON.stringify(ol.introText)
                    || !!l.looksGrid.showInIframe !== !!ol.looksGrid.showInIframe) {
                    patches.push({
                        kind:  'looks-content',
                        path:  '/admin/contents/TEXT_LOOKS',
                        rawBody: {
                            body_nl: l.introText.nl || '',
                            body_en: l.introText.en || '',
                            body_fr: l.introText.fr || '',
                            is_via_file: false,
                            use_iframe: !!l.looksGrid.showInIframe,
                        },
                    });
                }
                // Look CTA label → the shared GLOBAL.LOOKS_DETAILS i18n row
                // (per language). PATCH /localization/{id}; a regenerate runs
                // post-save so the storefront JSON picks it up.
                if (JSON.stringify(l.overlay.ctaText) !== JSON.stringify(ol.overlay.ctaText) && looksCtaIdRef.current != null) {
                    patches.push({
                        kind:   'looks-cta',
                        path:   `/localization/${looksCtaIdRef.current}`,
                        rawBody: {
                            nl: l.overlay.ctaText?.nl || '',
                            en: l.overlay.ctaText?.en || '',
                            fr: l.overlay.ctaText?.fr || '',
                        },
                    });
                    looksCtaSaved = true;
                }
            }
            if (imageGalleryDirty) {
                const g  = imageGalleryConfig;
                const og = originalImageGalleryConfigRef.current;
                const push = (key, current, original) => {
                    if (String(current) !== String(original)) {
                        patches.push({ kind: 'img-gallery', path: `/admin/settings/${key}`, value: String(current) });
                    }
                };
                // Thumbnail position: modal 'above'/'below' → 'top'/'bottom';
                // left, right and hidden go as they are. 'hidden' is a value
                // of this same setting — it is what the detail page tests.
                const toLegacyPos = (p) => p === 'above' ? 'top'
                                       : p === 'below' ? 'bottom'
                                       : p;
                push('GALLERY_THUMBS_POSITION', toLegacyPos(g.thumbnailPosition), toLegacyPos(og.thumbnailPosition));
                push('DETAIL_USE_NEW_GALLERY',  b(g.useGrid),       b(og.useGrid));
                push('NEW_GALLERY_THUMBS_COUNT', g.maxThumbnails,    og.maxThumbnails);

                // NEW_GALLERY_CONFIG is a JSON-coerced setting. Pass the
                // object as-is; the mini-api JSON.encodes it server-side
                // (same pattern as SIDE_FILTER_SLICE/STATES).
                const arrowKeys = ['showArrows','arrowColor','arrowBgColor','showFullscreen','fullscreenArrowColor','fullscreenArrowBgColor'];
                const arrowsChanged = arrowKeys.some(k => g[k] !== og[k]);
                if (arrowsChanged) {
                    patches.push({
                        kind: 'img-gallery-json',
                        path: '/admin/settings/NEW_GALLERY_CONFIG',
                        value: {
                            main_arrows:  { display: !!g.showArrows,     color: g.arrowColor,           background: g.arrowBgColor },
                            thumb_arrows: { display: !!g.showFullscreen, color: g.fullscreenArrowColor, background: g.fullscreenArrowBgColor },
                        },
                    });
                }
            }
            if (productDetailInfoDirty) {
                const p  = productDetailInfoConfig;
                const op = originalProductDetailInfoConfigRef.current;
                const push = (key, current, original) => {
                    if (String(current) !== String(original)) {
                        patches.push({ kind: 'pdi', path: `/admin/settings/${key}`, value: String(current) });
                    }
                };
                const pushJson = (key, currentObj, originalObj) => {
                    if (JSON.stringify(currentObj) !== JSON.stringify(originalObj)) {
                        patches.push({ kind: 'pdi-json', path: `/admin/settings/${key}`, value: currentObj });
                    }
                };

                // Description texts per language → the legacy ';'-joined
                // nl;en;fr slots (order matches Product.php's explode read).
                const descCsv = (cfg, field) => ['nl', 'en', 'fr']
                    .map(l => String(cfg.descriptionTexts?.[l]?.[field] ?? '').trim())
                    .join(';');
                push('PRODUCT_TEXTS_LOCALE',      descCsv(p, 'page'), descCsv(op, 'page'));
                push('PRODUCT_TEXTS_META_LOCALE', descCsv(p, 'meta'), descCsv(op, 'meta'));

                // Layout — rebuild PRODUCT_DETAILS_ORDER from the modal's
                // blocks. We honour the existing CSV order (so any future
                // reorder UI just rewrites `layout.order`), filter out
                // blocks the user toggled off, and append any used blocks
                // that weren't in the original order (defensive — should
                // only happen when defaults are first applied). All modal
                // blocks have a legacy equivalent in modalToLegacyBlock
                // today; once a wash-instructions <section> ships on the
                // storefront, add the modal→legacy entry here.
                const modalToLegacyBlock = {
                    header:          'header',
                    sizeSelector:    'sizeSelector',
                    addToCart:       'addToCart',
                    stockByLocation: 'locationsStock',
                    variants:        'variantsList',
                    relatedProducts: 'related',
                    productInfo:     'productInfo',
                    extraText:       'extraText',
                };
                const orderCsv = (cfg) => {
                    const ord  = Array.isArray(cfg.layout.order) ? cfg.layout.order : [];
                    const used = Object.keys(modalToLegacyBlock).filter(k => cfg.layout.blocks[k]?.used);
                    const seq  = [...ord.filter(k => used.includes(k)), ...used.filter(k => !ord.includes(k))];
                    return seq.map(k => modalToLegacyBlock[k]).join(',');
                };
                push('PRODUCT_DETAILS_ORDER', orderCsv(p), orderCsv(op));
                push('PRODUCT_MOBILE_TITLE_FIRST', b(!!p.layout.mobileTitleFirst), b(!!op.layout.mobileTitleFirst));
                push('PRODUCT_MOBILE_STICKY_CART', b(!!p.layout.mobileStickyCart), b(!!op.layout.mobileStickyCart));

                // Details list — flatten the 3 groups into a single CSV
                // following the canonical legacy order (so toggling never
                // reshuffles unrelated fields).
                const FIELD_ORDER = [
                    'id','brand','name','reference','color','color_brand','season',
                    'category_1','category_2','category_3','category_4','category_5','category_6','category_7',
                    'description_1','description_2','description_3','description_4','description_5',
                    'detail_1','detail_2','detail_3','detail_4','detail_5',
                ];
                const fieldsCsvOf = (cfg) => {
                    const all = { ...cfg.detailsList.identity, ...cfg.detailsList.categories, ...cfg.detailsList.descriptions };
                    return FIELD_ORDER.filter(k => all[k]).join(',');
                };
                push('SHOW_FIELDS_ON_DETAIL_PAGE', fieldsCsvOf(p), fieldsCsvOf(op));
                // Sections open — reverse the same modal-key → legacy-key
                // mapping used by the loader.
                const sectionsMap = {
                    productDetails:   'details',
                    variants:         'variants',
                    relatedProducts:  'related',
                    articleInfo:      'information',
                    washInstructions: 'washAndCare',
                    stockByStore:     'storeStock',
                };
                const toLegacyStates = (modalObj) => Object.fromEntries(
                    Object.entries(sectionsMap).map(([modalK, legacyK]) => [legacyK, !!modalObj[modalK]])
                );
                pushJson('PRODUCT_DETAILS_CONTAINER_STATES', toLegacyStates(p.sectionsOpen.desktop), toLegacyStates(op.sectionsOpen.desktop));
                pushJson('PRODUCT_MOBILE_CONTAINER_STATES',  toLegacyStates(p.sectionsOpen.mobile),  toLegacyStates(op.sectionsOpen.mobile));

                // Related — DETAILS_COLOR_DISPLAY is 'image' or 'color', nothing else.
                const modalToLegacyVariant = (v) => (v === 'colorImage' ? 'image' : 'color');
                push('PRODUCT_RELATED_ARTICLES_AMOUNT', p.related.maxToShow,                        op.related.maxToShow);
                // Always sent with this section: an earlier version could store
                // a value the storefront shows no variants for, and the loader
                // folds that onto 'color' — so form state alone would never
                // rewrite it.
                patches.push({ kind: 'pdi', path: '/admin/settings/DETAILS_COLOR_DISPLAY', value: modalToLegacyVariant(p.related.variantsDisplay) });
                push('DETAILS_COLOR_SHOW_OUT_OF_STOCK', b(p.related.showOutOfStock),                b(op.related.showOutOfStock));
                push('DETAILS_COLOR_DISPLAY_BORDER',    b(p.related.highlightSelected),             b(op.related.highlightSelected));

                // Stock
                push('SHOW_AVAILABLE_STOCK',        b(p.stock.showStockStatus),     b(op.stock.showStockStatus));
                push('SHOW_AVAILABLE_STOCK_STORES', b(p.stock.showStockByStore),    b(op.stock.showStockByStore));
                push('HIDE_STORE_IF_NO_RECORD',     b(p.stock.hideWhenSizeUnknown), b(op.stock.hideWhenSizeUnknown));

                // Title & URL — three template strings + one CSV. Serialise
                // both sides so the dirty-compare honours chip reorder /
                // text edits but ignores fresh chip ids.
                const tau    = p.titleAndUrl  || {};
                const tauOrig = op.titleAndUrl || {};
                push('SHOW_FIELDS_ON_DETAIL_TAB',        serializeChipsToTemplate(tau.browserTab?.used),     serializeChipsToTemplate(tauOrig.browserTab?.used));
                push('SHOW_FIELDS_ON_DETAIL_TITLE',      serializeChipsToTemplate(tau.pageHeading?.used),    serializeChipsToTemplate(tauOrig.pageHeading?.used));
                push('SHOW_FIELDS_ON_DETAIL_SUBHEADING', serializeChipsToTemplate(tau.pageSubheading?.used), serializeChipsToTemplate(tauOrig.pageSubheading?.used));
                push('DETAIL_PAGE_URL_SECTION',          serializeChipsToCsv     (tau.urlSlug?.used),        serializeChipsToCsv     (tauOrig.urlSlug?.used));
                push('SEO_PRODUCT_NAME',                 serializeChipsToTemplate(tau.schemaName?.used),     serializeChipsToTemplate(tauOrig.schemaName?.used));

                // Breadcrumb levels — CSV of legacy keys.
                const bcCsv     = (p.breadcrumb?.used  || []).join(',');
                const bcCsvOrig = (op.breadcrumb?.used || []).join(',');
                push('DETAIL_PAGE_NAV_SECTION', bcCsv, bcCsvOrig);

                // Structured data for search engines (bot version)
                push('SEO_BREADCRUMB_SCHEMA', b(!!p.seo?.breadcrumbSchema), b(!!op.seo?.breadcrumbSchema));
                push('SEO_PRODUCT_VARIANTS',  b(!!p.seo?.productVariants),  b(!!op.seo?.productVariants));
            }

            // Carousel slides — POST new, PATCH changed, DELETE removed.
            // These hit /admin/carousel/* (table CRUD) instead of
            // /admin/settings, so they ride a separate ops list. Image
            // fields are intentionally skipped: image upload runs via a
            // dedicated multipart endpoint in a later round, and PATCH on
            // the carousel route doesn't touch image columns either —
            // existing server-side images stay intact.
            // A new slide / cell can carry an image that is already on the
            // server (a row copied from another language): the create request
            // then points the new row at that same file. A picked file is
            // uploaded after the create, as before.
            const keptImageFields = (row) => {
                const kept = (img) => (img && img.name && !img.file && !img.pendingRemove ? img : null);
                const a = kept(row.desktopImage), b2 = kept(row.alternativeImage);
                return {
                    ...(a  ? { image: a.name,         mime_type: a.mime || null }         : {}),
                    ...(b2 ? { second_image: b2.name, second_mime_type: b2.mime || null } : {}),
                };
            };
            const carouselOps = [];
            if (carouselDirty) {
                const langs = ['nl', 'en', 'fr'];
                for (const lang of langs) {
                    // pendingDelete rows drop out of `current`, so the
                    // orig-vs-current serverId diff below emits their DELETE.
                    const current  = (carouselConfig.slides?.[lang] || []).filter(s => !s.pendingDelete);
                    const original = originalCarouselConfigRef.current.slides?.[lang] || [];
                    const origById = new Map(
                        original.filter(s => s.serverId != null).map(s => [s.serverId, s])
                    );
                    const currentServerIds = new Set(
                        current.map(s => s.serverId).filter(id => id != null)
                    );

                    // POST for slides without a serverId (newly added).
                    for (const s of current) {
                        if (s.serverId == null) {
                            carouselOps.push({
                                kind:   'carousel-create',
                                crud:   { type: 'create', row: s },
                                method: 'POST',
                                path:   '/admin/carousel',
                                // Links the create response's new id back to this
                                // slide so image uploads can target it afterwards.
                                slideRef: { lang, tempId: s.id },
                                body: {
                                    lang,
                                    link:         s.linkUrl     || null,
                                    active:       s.active ? 1 : 0,
                                    order:        Number(s.order) || 0,
                                    text_desktop: s.hoverDesktop || null,
                                    text_mobile:  s.hoverMobile  || null,
                                    ...keptImageFields(s),
                                },
                            });
                        }
                    }
                    // PATCH for slides whose tracked fields changed.
                    for (const s of current) {
                        if (s.serverId == null) continue;
                        const o = origById.get(s.serverId);
                        if (!o) continue;
                        const changed = (
                            s.linkUrl      !== o.linkUrl     ||
                            !!s.active     !== !!o.active    ||
                            Number(s.order) !== Number(o.order) ||
                            s.hoverDesktop !== o.hoverDesktop ||
                            s.hoverMobile  !== o.hoverMobile
                        );
                        if (changed) {
                            carouselOps.push({
                                kind:   'carousel-update',
                                crud:   { type: 'update', row: s },
                                method: 'PATCH',
                                path:   `/admin/carousel/${s.serverId}`,
                                // '' (not null) for an emptied field: the
                                // mini-api reads null as "leave unchanged", so
                                // a cleared link/text never got saved.
                                body: {
                                    lang,
                                    link:         s.linkUrl     || '',
                                    active:       s.active ? 1 : 0,
                                    order:        Number(s.order) || 0,
                                    text_desktop: s.hoverDesktop || '',
                                    text_mobile:  s.hoverMobile  || '',
                                },
                            });
                        }
                    }
                    // DELETE for slides present in the original snapshot but
                    // not in the current list (removed by the user).
                    for (const o of original) {
                        if (o.serverId != null && !currentServerIds.has(o.serverId)) {
                            carouselOps.push({
                                kind:   'carousel-delete',
                                crud:   { type: 'delete', id: o.serverId },
                                method: 'DELETE',
                                path:   `/admin/carousel/${o.serverId}`,
                                body:   null,
                            });
                        }
                    }
                }

                // Carousel settings (display + hover + behavior + overlay) —
                // PER LANGUAGE. Each language diffs and writes only its own
                // HOME_GALLERY_CONFIG_{L} / overlay / scalar keys.
                // Overlay writer — mirrors carReadDevice on load. Position
                // hyphen → space (storefront does `.includes('top ')`); the
                // desktop sub-object also carries the three shared flags.
                const carPositionToBackend = (p) => typeof p === 'string' ? p.replace(/-/g, ' ') : 'bottom center';
                const carWriteDevice = (ov, base, withFlags, parent) => ({
                    ...base,
                    background:  ov.background ?? base.background,
                    color:       ov.textColor  ?? base.color,
                    position:    carPositionToBackend(ov.position),
                    fontSize:    Number(ov.size)  || base.fontSize || 12,
                    size:        Number(ov.width) || base.size     || 10,
                    styleBold:   !!ov.bold,
                    styleItalic: !!ov.italic,
                    styleLined:  !!ov.underline,
                    styleStrike: !!ov.strike,
                    ...(withFlags ? {
                        onlyOnHover:            !!parent.onlyOnHover,
                        keepTextDisplayed:      !!parent.alwaysVisible,
                        useDesktopTextFallback: !!parent.useDesktopOnMobile,
                    } : {}),
                });
                // JSON blob per language — merge the modal-managed keys on top
                // of the raw server JSON (kept per lang on load) so legacy
                // fields like `showIndex` survive.
                const galleryJsonFor = (cfgSettings) => {
                    // overlayConfig lives in its OWN key (HOME_GALLERY_OVERLAY_CONFIG_*),
                    // so strip any legacy inline copy out of HOME_GALLERY_CONFIG.
                    const { overlayConfig: _legacyOverlay, ...baseNoOverlay } = cfgSettings.__rawGalleryConfig || {};
                    return {
                        ...baseNoOverlay,
                        autoSlide:              !!cfgSettings.behavior?.autoAdvance,
                        slideInterval:          (Number(cfgSettings.behavior?.timePerSlide) || 0) * 1000,
                        // showControls = always visible; showControlsOnHover only
                        // counts when that is off (see the loader).
                        showControls:           !!cfgSettings.behavior?.showArrows && !cfgSettings.behavior?.arrowsOnHover,
                        showControlsOnHover:    !!cfgSettings.behavior?.showArrows && !!cfgSettings.behavior?.arrowsOnHover,
                        showControlsBackground: !!cfgSettings.behavior?.arrowsBackground,
                        maxHeight:              Number(cfgSettings.display?.maxHeight) || 0,
                        maxHeightUnit:          cfgSettings.display?.maxHeightUnit || 'vh',
                        // margin = [top, bottom]; storefront reads it for the
                        // carousel wrapper spacing.
                        margin:                 [Number(cfgSettings.display?.spacingTop) || 0, Number(cfgSettings.display?.spacingBottom) || 0],
                        animation:              cfgSettings.behavior?.transition || 'fade',
                        imageSize:              cfgSettings.display?.imageFit || 'contain',
                    };
                };
                const overlayJsonFor = (cfgSettings) => {
                    const rawOverlayBase = cfgSettings.__rawOverlayConfig || {};
                    const to = cfgSettings.textOverlay || {};
                    return {
                        ...rawOverlayBase,
                        desktop: carWriteDevice(to.desktop || {}, rawOverlayBase.desktop || {}, true,  to),
                        mobile:  carWriteDevice(to.mobile  || {}, rawOverlayBase.mobile  || {}, false, to),
                    };
                };
                for (const cl of ['nl', 'en', 'fr']) {
                    const L      = cl.toUpperCase();
                    const cs     = carouselConfig.settings?.[cl] || {};
                    const csOrig = originalCarouselConfigRef.current.settings?.[cl] || {};
                    const csChanged = (current, original) => String(current) !== String(original);

                    const jsonCurrent  = galleryJsonFor(cs);
                    const jsonOriginal = galleryJsonFor(csOrig);
                    if (JSON.stringify(jsonCurrent) !== JSON.stringify(jsonOriginal)) {
                        patches.push({ kind: 'carousel-cfg', path: `/admin/settings/HOME_GALLERY_CONFIG_${L}`, value: jsonCurrent });
                    }
                    // Caption overlay → its own per-lang key, matching the storefront
                    // (StartupController reads HOME_GALLERY_OVERLAY_CONFIG_{lang}).
                    const overlayCurrent  = overlayJsonFor(cs);
                    const overlayOriginal = overlayJsonFor(csOrig);
                    if (JSON.stringify(overlayCurrent) !== JSON.stringify(overlayOriginal)) {
                        patches.push({ kind: 'carousel-cfg', path: `/admin/settings/HOME_GALLERY_OVERLAY_CONFIG_${L}`, value: overlayCurrent });
                    }
                    // Per-lang scalar/bool keys.
                    const pushLang = (keyBase, valCur, valOrig, coerce) => {
                        if (csChanged(valCur, valOrig)) {
                            patches.push({ kind: 'carousel-cfg', path: `/admin/settings/${keyBase}_${L}`, value: coerce ? coerce(valCur) : valCur });
                        }
                    };
                    pushLang('STRETCH_GALLERY_FULL_WIDTH',    cs.display?.fullWidth,    csOrig.display?.fullWidth,    v => b(v));
                    pushLang('GALLERY_HOVER_ANIM_TYPE',       cs.hover?.effect,         csOrig.hover?.effect,         v => String(v || 'none'));
                    pushLang('GALLERY_HOVER_ANIM_ZOOM_SCALE', cs.hover?.zoomLevel,      csOrig.hover?.zoomLevel,      v => String(Number(v) || 0));
                    // Seconds in the modal, milliseconds in the setting.
                    pushLang('GALLERY_HOVER_ANIM_ZOOM_SPEED', cs.hover?.animationSpeed, csOrig.hover?.animationSpeed, v => String(zoomSpeedToMs(v)));
                }
                // HOME_GALLERY_INTERVAL is deliberately not written: the carousel
                // reads slideInterval from its per-language JSON, that key times
                // the information banner.
            }

            // Image grid cells — same shape as carousel, different endpoint
            // (`/admin/image-grid/*`). Hits the same dirty-aware POST/PATCH/
            // DELETE flow.
            const imageGridOps = [];
            if (imageGridDirty) {
                const langs = ['nl', 'en', 'fr'];
                for (const lang of langs) {
                    // pendingDelete rows drop out of `current`, so the
                    // orig-vs-current serverId diff below emits their DELETE.
                    const current  = (imageGridConfig.cells?.[lang] || []).filter(c => !c.pendingDelete);
                    const original = originalImageGridConfigRef.current.cells?.[lang] || [];
                    const origById = new Map(
                        original.filter(c => c.serverId != null).map(c => [c.serverId, c])
                    );
                    const currentServerIds = new Set(
                        current.map(c => c.serverId).filter(id => id != null)
                    );

                    for (const c of current) {
                        if (c.serverId == null) {
                            imageGridOps.push({
                                kind:   'imagegrid-create',
                                crud:   { type: 'create', row: c },
                                method: 'POST',
                                path:   '/admin/image-grid',
                                // Links the create response's new id back to this
                                // cell so image uploads can target it afterwards.
                                cellRef: { lang, tempId: c.id },
                                body: {
                                    lang,
                                    link:         c.linkUrl     || null,
                                    active:       c.active ? 1 : 0,
                                    order:        Number(c.order) || 0,
                                    width:        Math.max(1, Number(c.width)  || 1),
                                    height:       Math.max(1, Number(c.height) || 1),
                                    text_desktop: c.hoverDesktop || null,
                                    text_mobile:  c.hoverMobile  || null,
                                    ...keptImageFields(c),
                                },
                            });
                        }
                    }
                    for (const c of current) {
                        if (c.serverId == null) continue;
                        const o = origById.get(c.serverId);
                        if (!o) continue;
                        const changed = (
                            c.linkUrl      !== o.linkUrl     ||
                            !!c.active     !== !!o.active    ||
                            Number(c.order) !== Number(o.order) ||
                            Number(c.width)  !== Number(o.width)  ||
                            Number(c.height) !== Number(o.height) ||
                            c.hoverDesktop !== o.hoverDesktop ||
                            c.hoverMobile  !== o.hoverMobile
                        );
                        if (changed) {
                            imageGridOps.push({
                                kind:   'imagegrid-update',
                                crud:   { type: 'update', row: c },
                                method: 'PATCH',
                                path:   `/admin/image-grid/${c.serverId}`,
                                // '' (not null) for an emptied field — see the
                                // carousel PATCH above.
                                body: {
                                    lang,
                                    link:         c.linkUrl     || '',
                                    active:       c.active ? 1 : 0,
                                    order:        Number(c.order) || 0,
                                    width:        Math.max(1, Number(c.width)  || 1),
                                    height:       Math.max(1, Number(c.height) || 1),
                                    text_desktop: c.hoverDesktop || '',
                                    text_mobile:  c.hoverMobile  || '',
                                },
                            });
                        }
                    }
                    for (const o of original) {
                        if (o.serverId != null && !currentServerIds.has(o.serverId)) {
                            imageGridOps.push({
                                kind:   'imagegrid-delete',
                                crud:   { type: 'delete', id: o.serverId },
                                method: 'DELETE',
                                path:   `/admin/image-grid/${o.serverId}`,
                                body:   null,
                            });
                        }
                    }
                }

                // Image grid settings — PER LANGUAGE. Each language diffs and
                // writes only its own IMAGE_GRID_CONFIG_{L} / scalar keys.
                // Position: modal hyphen → backend space (storefront's
                // home.component.html checks `.includes('top ')` etc.).
                const positionToBackend = (p) => typeof p === 'string'
                    ? p.replace(/-/g, ' ')
                    : 'bottom center';
                // Per-device writer — mirrors the load-time readDevice.
                // Mobile sub-object lacks the shared desktop flags backend-side;
                // the spread of `baseDevice` preserves whatever was stored there
                // (e.g. seeded by mig166) and only overrides the style fields
                // the modal owns.
                const writeDevice = (ovDevice, baseDevice, withDesktopFlags, ov) => ({
                    ...baseDevice,
                    background:  ovDevice.background ?? baseDevice.background,
                    color:       ovDevice.textColor  ?? baseDevice.color,
                    position:    positionToBackend(ovDevice.position),
                    fontSize:    Number(ovDevice.size)  || baseDevice.fontSize || 12,
                    size:        Number(ovDevice.width) || baseDevice.size     || 10,
                    styleBold:   !!ovDevice.bold,
                    styleItalic: !!ovDevice.italic,
                    styleLined:  !!ovDevice.underline,
                    styleStrike: !!ovDevice.strike,
                    ...(withDesktopFlags
                        ? {
                            onlyOnHover:            !!ov.onlyOnHover,
                            keepTextDisplayed:      !!ov.alwaysVisible,
                            useDesktopTextFallback: !!ov.useDesktopOnMobile,
                          }
                        : {}),
                });
                const gridJsonFor = (cfgSettings) => {
                    const rawGridBase = cfgSettings.__rawGridConfig || {};
                    const baseOverlay = rawGridBase.overlay || {};
                    const baseDesktop = baseOverlay.desktop || {};
                    const baseMobile  = baseOverlay.mobile  || {};
                    const ov          = cfgSettings.textOverlay         || {};
                    const ovDesktop   = ov.desktop                       || {};
                    const ovMobile    = ov.mobile                        || {};
                    const marginArr   = Array.isArray(cfgSettings.layout?.margin)
                        ? cfgSettings.layout.margin
                        : [20, 0];
                    return {
                        ...rawGridBase,
                        // Only the fields the storefront actually reads from
                        // `imageGridConfig[lang]` round-trip: `margin` (mig164)
                        // and the `overlay.{desktop,mobile}` sub-objects (mig166).
                        margin:      [Number(marginArr[0]) || 0, Number(marginArr[1]) || 0],
                        overlay: {
                            ...baseOverlay,
                            desktop: writeDevice(ovDesktop, baseDesktop, /*withDesktopFlags*/ true,  ov),
                            mobile:  writeDevice(ovMobile,  baseMobile,  /*withDesktopFlags*/ false, ov),
                        },
                    };
                };
                for (const gl of ['nl', 'en', 'fr']) {
                    const L      = gl.toUpperCase();
                    const gs     = imageGridConfig.settings?.[gl] || {};
                    const gsOrig = originalImageGridConfigRef.current.settings?.[gl] || {};
                    const gsChanged = (current, original) => String(current) !== String(original);

                    const gridJsonCurrent  = gridJsonFor(gs);
                    const gridJsonOriginal = gridJsonFor(gsOrig);
                    if (JSON.stringify(gridJsonCurrent) !== JSON.stringify(gridJsonOriginal)) {
                        patches.push({ kind: 'imagegrid-cfg', path: `/admin/settings/IMAGE_GRID_CONFIG_${L}`, value: gridJsonCurrent });
                    }
                    const pushLangGrid = (keyBase, valCur, valOrig, coerce) => {
                        if (gsChanged(valCur, valOrig)) {
                            patches.push({ kind: 'imagegrid-cfg', path: `/admin/settings/${keyBase}_${L}`, value: coerce ? coerce(valCur) : valCur });
                        }
                    };
                    pushLangGrid('IMAGE_GRID_COLS',                gs.layout?.columns,          gsOrig.layout?.columns,          v => String(Number(v) || 0));
                    pushLangGrid('IMAGE_GRID_GUTTER',              gs.layout?.gap,              gsOrig.layout?.gap,              v => String(Number(v) || 0));
                    // IMAGE_GRID_KEEP_GRID_ON_MOBILE per lang (mig158). The rows end
                    // in _N/_E/_F (settings.attribute is varchar(32)), and the
                    // storefront casts with (bool) — so '1'/'0', never 'false'.
                    if (gsChanged(!!gs.layout?.keepGridOnMobile, !!gsOrig.layout?.keepGridOnMobile)) {
                        patches.push({ kind: 'imagegrid-cfg', path: `/admin/settings/IMAGE_GRID_KEEP_GRID_ON_MOBILE_${L.charAt(0)}`, value: b(gs.layout?.keepGridOnMobile) });
                    }
                    pushLangGrid('GRID_HOVER_ANIM_TYPE',           gs.hover?.effect,            gsOrig.hover?.effect,            v => String(v || 'none'));
                    pushLangGrid('GRID_HOVER_ANIM_ZOOM_SCALE',     gs.hover?.zoomLevel,         gsOrig.hover?.zoomLevel,         v => String(Number(v) || 0));
                    // Seconds in the modal, milliseconds in the setting.
                    pushLangGrid('GRID_HOVER_ANIM_ZOOM_SPEED',     gs.hover?.animationSpeed,    gsOrig.hover?.animationSpeed,    v => String(zoomSpeedToMs(v)));
                }
            }

            // Stores — one PATCH /stores/{id} per changed store, with only the
            // columns that actually changed (mirrors the legacy admin, which
            // sends e.g. {hours_fri: "09:30 - 15:30"}).
            // Map settings — 4 settings PATCHes (ride the shared `patches` list)
            // + the style file via POST /admin/maps-style (own op, custom body).
            const mapStyleOps = [];
            if (mapSettingsDirty) {
                const m = mapSettings, om = originalMapSettingsRef.current;
                if (!!m.multi !== !!om.multi) {
                    patches.push({ kind: 'map', path: '/admin/settings/ABOUT_US_MAP_MULTI', value: m.multi ? '1' : '0' });
                }
                if ((m.position || 'bottom') !== (om.position || 'bottom')) {
                    patches.push({ kind: 'map', path: '/admin/settings/ABOUT_US_MAP_POSITION', value: m.position || 'bottom' });
                }
                if (String(m.zoom) !== String(om.zoom)) {
                    patches.push({ kind: 'map', path: '/admin/settings/ABOUT_US_MAP_ZOOM', value: String(m.zoom) });
                }
                if (String(m.zoomMax) !== String(om.zoomMax)) {
                    patches.push({ kind: 'map', path: '/admin/settings/ABOUT_US_MAP_ZOOM_MAX', value: String(m.zoomMax) });
                }
                if (String(m.style || '') !== String(om.style || '')) {
                    mapStyleOps.push({ kind: 'map-style', method: 'POST', path: '/admin/maps-style', body: { style: m.style || '[]' } });
                }
            }

            const storeOps = [];
            if (storesDirty || separatorDirty) {
                const origById = Object.fromEntries(originalStoresRef.current.map(st => [st.id, st]));
                for (const st of stores) {
                    const curCols  = storeFormToColumns(st, hoursSeparator);
                    const orig     = origById[st.id];
                    const origCols = orig ? storeFormToColumns(orig, originalHoursSeparatorRef.current) : null;
                    const body = {};
                    for (const col of Object.keys(curCols)) {
                        if (!origCols || JSON.stringify(curCols[col]) !== JSON.stringify(origCols[col])) {
                            body[col] = curCols[col];
                        }
                    }
                    if (Object.keys(body).length) {
                        storeOps.push({ kind: 'store', method: 'PATCH', path: `/stores/${st.id}`, body });
                    }
                }
            }

            // Dynamic pages — create (POST) / update (PATCH) / soft-delete.
            // Only edited languages (present in `content`) are written, in the
            // shape the page's storage form needs (dynPageBodyToSend: text in
            // the columns, designer / own HTML in files); untouched languages
            // are omitted so what the shop holds for them stays intact.
            // Information banners — create / update changed columns only /
            // soft-delete removed. Content lives in loc_* (single banner) or
            // items_* (item list); the inactive side is cleared on save.
            const bannerFormToColumns = (b) => {
                const multi = !!b.multipleItems;
                return {
                    name:             b.referenceName || '',
                    active:           b.isActive ? 1 : 0,
                    date_from:        b.activeFrom || null,
                    date_until:       b.activeTo   || null,
                    position:         BANNER_POS_TO_BACKEND[b.position] || 'top',
                    background_color: b.bgColor   || '',
                    foreground_color: b.textColor || '',
                    height:           Number(b.height) || 0,
                    is_animated:      b.scrollText ? 1 : 0,
                    is_item_list:     multi ? 1 : 0,
                    loc_nl:    !multi ? (b.content?.nl || '') : '',
                    loc_en:    !multi ? (b.content?.en || '') : '',
                    loc_fr:    !multi ? (b.content?.fr || '') : '',
                    items_nl:   multi ? (b.content?.nl || '') : '',
                    items_en:   multi ? (b.content?.en || '') : '',
                    items_fr:   multi ? (b.content?.fr || '') : '',
                };
            };
            const bannerOps = [];
            if (bannersDirty) {
                const origBanners = originalBannersRef.current;
                const origById = Object.fromEntries(origBanners.filter(b => b.serverId != null).map(b => [b.serverId, b]));
                const curServerIds = new Set(banners.filter(b => b.serverId != null).map(b => b.serverId));
                for (const ob of origBanners) {
                    if (ob.serverId != null && !curServerIds.has(ob.serverId)) {
                        bannerOps.push({ kind: 'banner-del', crud: { type: 'delete', id: ob.serverId }, method: 'DELETE', path: `/information-banner/${ob.serverId}`, body: {} });
                    }
                }
                for (const b of banners) {
                    const curCols = bannerFormToColumns(b);
                    if (b.serverId == null) {
                        bannerOps.push({ kind: 'banner-new', crud: { type: 'create', row: b }, method: 'POST', path: '/information-banner', body: curCols });
                    } else {
                        const orig = origById[b.serverId];
                        const origCols = orig ? bannerFormToColumns(orig) : null;
                        const body = {};
                        for (const col of Object.keys(curCols)) {
                            if (!origCols || JSON.stringify(curCols[col]) !== JSON.stringify(origCols[col])) {
                                body[col] = curCols[col];
                            }
                        }
                        if (Object.keys(body).length) {
                            bannerOps.push({ kind: 'banner-upd', crud: { type: 'update', row: b }, method: 'PATCH', path: `/information-banner/${b.serverId}`, body });
                        }
                    }
                }
            }

            const dynamicPageOps = [];
            if (dynamicPagesDirty) {
                const origDyn = originalDynamicPagesRef.current;
                const origById = Object.fromEntries(origDyn.filter(p => p.serverId != null).map(p => [p.serverId, p]));
                const curServerIds = new Set(dynamicPages.filter(p => p.serverId != null).map(p => p.serverId));
                // soft-deletes
                for (const op of origDyn) {
                    if (op.serverId != null && !curServerIds.has(op.serverId)) {
                        dynamicPageOps.push({ kind: 'dynpage-del', crud: { type: 'delete', id: op.serverId }, method: 'DELETE', path: `/dynamic-pages/${op.serverId}`, body: {} });
                    }
                }
                for (const p of dynamicPages) {
                    const { flags: bodyFlags, bodies: bodyLangs } = dynPageBodyToSend(p);
                    const hasContent = Object.keys(bodyLangs).length > 0;
                    const meta = {
                        route:    p.slug || '',
                        position: DYN_POS_TO_BACKEND[p.position] || 'HIDDEN',
                        header_position: (p.headerPosition || 'EXTRA').toUpperCase(),
                        loc_nl:   p.titles?.nl || '',
                        loc_en:   p.titles?.en || '',
                        loc_fr:   p.titles?.fr || '',
                        meta_title_nl: p.metaTitle?.nl || '',
                        meta_title_en: p.metaTitle?.en || '',
                        meta_title_fr: p.metaTitle?.fr || '',
                        meta_description_nl: p.metaDescription?.nl || '',
                        meta_description_en: p.metaDescription?.en || '',
                        meta_description_fr: p.metaDescription?.fr || '',
                        active:   p.isActive ? 1 : 0,
                        use_iframe: p.iframe ? 1 : 0,
                    };
                    if (p.serverId == null) {
                        dynamicPageOps.push({ kind: 'dynpage-new', crud: { type: 'create', row: p }, method: 'POST', path: '/dynamic-pages', body: { ...meta, ...bodyFlags, ...bodyLangs } });
                    } else {
                        const orig = origById[p.serverId];
                        const metaChanged = !orig
                            || p.slug !== orig.slug || p.position !== orig.position
                            || (p.headerPosition || 'EXTRA') !== (orig.headerPosition || 'EXTRA')
                            || p.isActive !== orig.isActive || p.iframe !== orig.iframe
                            || JSON.stringify(p.titles) !== JSON.stringify(orig.titles)
                            || JSON.stringify(p.metaTitle) !== JSON.stringify(orig.metaTitle)
                            || JSON.stringify(p.metaDescription) !== JSON.stringify(orig.metaDescription);
                        // The storage form itself changed (text ↔ designer ↔ own
                        // HTML): the flags go out even when no language was edited.
                        const editorChanged = !orig || (p.editor || 'unlayer') !== (orig.editor || 'unlayer');
                        if (metaChanged || hasContent || editorChanged) {
                            dynamicPageOps.push({
                                kind: 'dynpage-upd', method: 'PATCH', path: `/dynamic-pages/${p.serverId}`,
                                crud: { type: 'update', row: p },
                                body: { ...meta, ...(hasContent || editorChanged ? { ...bodyFlags, ...bodyLangs } : {}) },
                            });
                        }
                    }
                }
            }

            // Sections that had changes going in — the report lists which of these
            // were saved and which were not.
            const dirtySections = {
                containers: containersDirty, order: orderDirty, showLanding: showLandingDirty, order404: order404Dirty,
                productGrid: productGridDirty, productCard: productCardDirty, styleSettings: styleSettingsDirty,
                groupsFilter: groupsFilterDirty, globalWidths: globalWidthsDirty, headerLogo: headerLogoDirty,
                navigation: navigationDirty, navbarOrder: navbarOrderDirty, footer: footerDirty, extraFooter: extraFooterDirty,
                staticPages: staticPagesDirty, cards: cardsDirty, brandsConfig: brandsConfigDirty, overige: overigeConfigDirty,
                cadeaubonConfig: cadeaubonConfigDirty, cadeaubonPlaceholders: cadeaubonPlaceholdersDirty, cadeaubonLayouts: cadeaubonLayoutsDirty,
                processing: processingConfigDirty, sync: syncConfigDirty, customerGroups: customerGroupsDirty, looks: looksConfigDirty,
                imageGallery: imageGalleryDirty, pdi: productDetailInfoDirty, carousel: carouselDirty, imageGrid: imageGridDirty,
                map: mapSettingsDirty, stores: storesDirty || separatorDirty, banners: bannersDirty, dynamicPages: dynamicPagesDirty,
                brandContent: brandContentDirty,
            };

            // One request per op. A request that fails (or throws) must never take
            // the others down with it: every op resolves to itself plus its
            // `response`, so afterwards we know what happened to each one.
            const send = (op) => SftGlobalData.post('webshop&action=proxy', {
                key:        props.api,
                webshop_id: webshopId,
                sftUserId:  props.login?.sft_user_id,
                user:       props.login?.login,
                method:     op.method,
                path:       op.path,
                body:       op.body,
            }).then(r => ({ ...op, response: r }))
              .catch(e => ({ ...op, response: { success: false, message: e?.message || 'network error' } }));
            const results = await Promise.all([
                // Most settings PATCHes are { value: ... }. Patches that target a
                // different endpoint shape (e.g. the `/admin/contents/{attribute}`
                // content rows) set `rawBody` instead and we forward it verbatim.
                ...patches.map(p => send({ ...p, method: 'PATCH', body: p.rawBody !== undefined ? p.rawBody : { value: p.value } })),
                ...[
                    carouselOps, navbarOrderOps, imageGridOps, externalLinkOps, storeOps, mapStyleOps, fontGenerateOps, dynamicPageOps, bannerOps, overigeOps, cadeaubonOps, cadeaubonLayoutOps, customerGroupOps
                ].flat().map(send),
            ]);

            // ── What went through, per section ─────────────────────────────
            // A failed request no longer aborts the whole save. Its SECTION stays
            // dirty (none of the follow-up below runs for it), every other section
            // is finished as usual, and the screen gets a report of both.
            const failedOps = [...containerFailed, ...results.filter(r => !opSucceeded(r))];
            const failedSections = new Set([...failedOps.map(sectionOfOp), ...extraFailures.map(x => x.section)]);
            const saved = (key) => !!dirtySections[key] && !failedSections.has(key);
            if (failedSections.has('looks')) looksCtaSaved = false;

            // Half-saved CRUD lists: created rows get their server id and the
            // baseline moves to what the server now holds, so a retry sends only
            // what failed — no second POST, no DELETE of a row already gone.
            // (State is set from this call's closure values, like the rest of
            // this function.)
            const crudResults = (section) => results.filter(r => r.crud && sectionOfOp(r) === section);
            if (carouselDirty && failedSections.has('carousel')) {
                const res = crudResults('carousel');
                const slides = {}, base = {};
                for (const lang of ['nl', 'en', 'fr']) {
                    const rec = reconcileList(carouselConfig.slides?.[lang], originalCarouselConfigRef.current.slides?.[lang], res, IMAGE_ROW);
                    slides[lang] = rec.local;
                    base[lang]   = rec.baseline;
                }
                setCarouselConfig({ ...carouselConfig, slides });
                originalCarouselConfigRef.current = { ...originalCarouselConfigRef.current, slides: base };
            }
            if (imageGridDirty && failedSections.has('imageGrid')) {
                const res = crudResults('imageGrid');
                const cells = {}, base = {};
                for (const lang of ['nl', 'en', 'fr']) {
                    const rec = reconcileList(imageGridConfig.cells?.[lang], originalImageGridConfigRef.current.cells?.[lang], res, IMAGE_ROW);
                    cells[lang] = rec.local;
                    base[lang]  = rec.baseline;
                }
                setImageGridConfig({ ...imageGridConfig, cells });
                originalImageGridConfigRef.current = { ...originalImageGridConfigRef.current, cells: base };
            }
            if (footerDirty && failedSections.has('footer')) {
                const res = crudResults('footer');
                const links  = reconcileList(footerConfig.customLinks, originalFooterConfigRef.current.customLinks, res, SERVER_ID_ROW);
                const social = reconcileList(footerConfig.socialMedia, originalFooterConfigRef.current.socialMedia, res, SERVER_ID_ROW);
                setFooterConfig({ ...footerConfig, customLinks: links.local, socialMedia: social.local });
                originalFooterConfigRef.current = { ...originalFooterConfigRef.current, customLinks: links.baseline, socialMedia: social.baseline };
            }
            if (bannersDirty && failedSections.has('banners')) {
                const rec = reconcileList(banners, originalBannersRef.current, crudResults('banners'), SERVER_ID_ROW);
                setBanners(rec.local);
                originalBannersRef.current = rec.baseline;
            }
            if (dynamicPagesDirty && failedSections.has('dynamicPages')) {
                const rec = reconcileList(dynamicPages, originalDynamicPagesRef.current, crudResults('dynamicPages'), SERVER_ID_ROW);
                setDynamicPages(rec.local);
                originalDynamicPagesRef.current = rec.baseline;
            }
            if (cadeaubonPlaceholdersDirty && failedSections.has('cadeaubonPlaceholders')) {
                const rec = reconcileList(cadeaubonPlaceholders, originalPlaceholdersRef.current, crudResults('cadeaubonPlaceholders'), PLAIN_ID_ROW);
                setCadeaubonPlaceholders(rec.local);
                originalPlaceholdersRef.current = rec.baseline;
            }
            if (cadeaubonLayoutsDirty && failedSections.has('cadeaubonLayouts')) {
                const rec = reconcileList(cadeaubonLayouts, originalCadeaubonLayoutsRef.current, crudResults('cadeaubonLayouts'), LAYOUT_ROW);
                setCadeaubonLayouts(rec.local);
                originalCadeaubonLayoutsRef.current = rec.baseline;
            }
            if (customerGroupsDirty && failedSections.has('customerGroups')) {
                const rec = reconcileList(customerCategoryGroups, originalCustomerGroupsRef.current, crudResults('customerGroups'), PLAIN_ID_ROW);
                setCustomerCategoryGroups(rec.local);
                originalCustomerGroupsRef.current = rec.baseline;
            }

            // The follow-up of a save (uploads, refetches, baseline snapshots),
            // run per section: inside this function every `…Dirty` flag means
            // "had changes AND all of its requests went through", so a section
            // with a failed request is skipped and stays dirty for the retry.
            // (The body is the pre-existing success path, left at its indent.)
            await (async ({
                containersDirty, orderDirty, showLandingDirty, order404Dirty, productGridDirty,
                productCardDirty, styleSettingsDirty, groupsFilterDirty, globalWidthsDirty, headerLogoDirty,
                navigationDirty, navbarOrderDirty, footerDirty, extraFooterDirty, staticPagesDirty,
                cardsDirty, brandsConfigDirty, overigeConfigDirty, cadeaubonConfigDirty, cadeaubonPlaceholdersDirty,
                cadeaubonLayoutsDirty, processingConfigDirty, syncConfigDirty, customerGroupsDirty, looksConfigDirty,
                imageGalleryDirty, productDetailInfoDirty, carouselDirty, imageGridDirty, mapSettingsDirty,
                bannersDirty, dynamicPagesDirty, brandContentDirty, storesDirty, separatorDirty,
            }) => {
            // Carousel image/video uploads. Run AFTER the row CRUD so freshly
            // created slides have a server id; the file rides as base64 in the
            // JSON proxy body (mini-api decodes it). Done before the carousel
            // refetch below so the reload picks up the new image filenames.
            if (carouselDirty) {
                const newIdByTemp = new Map();
                for (const r of results) {
                    if (r.kind === 'carousel-create' && r.slideRef && r.response?.success && r.response?.data?.id != null) {
                        newIdByTemp.set(r.slideRef.tempId, r.response.data.id);
                    }
                }
                const uploadTasks = [];
                // × on an existing image only FLAGS it in the modal
                // (pendingRemove); the actual clear happens here on Save via
                // DELETE /admin/carousel/{id}/image(-second).
                const removeTasks = [];
                for (const lang of ['nl', 'en', 'fr']) {
                    for (const sl of (carouselConfig.slides?.[lang] || [])) {
                        if (sl.pendingDelete) continue; // row is being deleted — don't upload to it
                        const sid = sl.serverId ?? newIdByTemp.get(sl.id);
                        if (sid == null) continue;
                        if (sl.desktopImage?.file)     uploadTasks.push({ sid, slot: 'image',        img: sl.desktopImage });
                        if (sl.alternativeImage?.file) uploadTasks.push({ sid, slot: 'image-second', img: sl.alternativeImage });
                        if (sl.desktopImage?.pendingRemove)     removeTasks.push({ sid, slot: 'image' });
                        if (sl.alternativeImage?.pendingRemove) removeTasks.push({ sid, slot: 'image-second' });
                    }
                }
                // Removes + uploads are independent per file — run them
                // concurrently instead of one round-trip at a time (an 8-slide
                // upload used to serialize 8 base64 encodes + 8 POSTs).
                await Promise.all(removeTasks.map(task =>
                    SftGlobalData.post('webshop&action=proxy', {
                        key:        props.api,
                        webshop_id: webshopId,
                        sftUserId:  props.login?.sft_user_id,
                        user:       props.login?.login,
                        method:     'DELETE',
                        path:       `/admin/carousel/${task.sid}/${task.slot}`,
                    }).catch(() => null) /* refetch below shows the actual state either way */));
                const uploadFails = [];
                await Promise.all(uploadTasks.map(async (task) => {
                    try {
                        const b64 = await fileToBase64(task.img.file);
                        const up = await SftGlobalData.post('webshop&action=proxy', {
                            key:        props.api,
                            webshop_id: webshopId,
                            sftUserId:  props.login?.sft_user_id,
                            user:       props.login?.login,
                            method:     'POST',
                            path:       `/admin/carousel/${task.sid}/${task.slot}`,
                            body:       { image_base64: b64, filename: task.img.name, mime: task.img.mime || '' },
                        });
                        if (!up || !up.success) uploadFails.push(task.img.name);
                    } catch {
                        uploadFails.push(task.img.name);
                    }
                }));
                if (uploadFails.length) warnings.push({ section: 'carousel', files: uploadFails });
            }

            // Image-grid image uploads — same base64 flow as the carousel, after
            // the cell CRUD so new cells have a server id (mapped via cellRef).
            if (imageGridDirty) {
                const newGridIdByTemp = new Map();
                for (const r of results) {
                    if (r.kind === 'imagegrid-create' && r.cellRef && r.response?.success && r.response?.data?.id != null) {
                        newGridIdByTemp.set(r.cellRef.tempId, r.response.data.id);
                    }
                }
                const gridUploadTasks = [];
                // Same pendingRemove contract as the carousel above.
                const gridRemoveTasks = [];
                for (const lang of ['nl', 'en', 'fr']) {
                    for (const cl of (imageGridConfig.cells?.[lang] || [])) {
                        if (cl.pendingDelete) continue; // row is being deleted — don't upload to it
                        const cid = cl.serverId ?? newGridIdByTemp.get(cl.id);
                        if (cid == null) continue;
                        if (cl.desktopImage?.file)     gridUploadTasks.push({ cid, slot: 'image',        img: cl.desktopImage });
                        if (cl.alternativeImage?.file) gridUploadTasks.push({ cid, slot: 'image-second', img: cl.alternativeImage });
                        if (cl.desktopImage?.pendingRemove)     gridRemoveTasks.push({ cid, slot: 'image' });
                        if (cl.alternativeImage?.pendingRemove) gridRemoveTasks.push({ cid, slot: 'image-second' });
                    }
                }
                // Concurrent per file — same reasoning as the carousel block.
                await Promise.all(gridRemoveTasks.map(task =>
                    SftGlobalData.post('webshop&action=proxy', {
                        key:        props.api,
                        webshop_id: webshopId,
                        sftUserId:  props.login?.sft_user_id,
                        user:       props.login?.login,
                        method:     'DELETE',
                        path:       `/admin/image-grid/${task.cid}/${task.slot}`,
                    }).catch(() => null) /* refetch below shows the actual state either way */));
                const gridUploadFails = [];
                await Promise.all(gridUploadTasks.map(async (task) => {
                    try {
                        const b64 = await fileToBase64(task.img.file);
                        const up = await SftGlobalData.post('webshop&action=proxy', {
                            key:        props.api,
                            webshop_id: webshopId,
                            sftUserId:  props.login?.sft_user_id,
                            user:       props.login?.login,
                            method:     'POST',
                            path:       `/admin/image-grid/${task.cid}/${task.slot}`,
                            body:       { image_base64: b64, filename: task.img.name, mime: task.img.mime || '' },
                        });
                        if (!up || !up.success) gridUploadFails.push(task.img.name);
                    } catch {
                        gridUploadFails.push(task.img.name);
                    }
                }));
                if (gridUploadFails.length) warnings.push({ section: 'imageGrid', files: gridUploadFails });
            }

            // Header/logo image uploads (logo, header background, favicon). These
            // hit /admin/images/general/{TYPE}, which moves the file AND updates
            // the matching IMG_{TYPE} setting server-side — no row CRUD needed.
            if (headerLogoDirty) {
                const HDR_IMG_TYPES = { logoUrl: 'LOGO', backgroundUrl: 'HEADER', faviconUrl: 'ICON' };
                const imgs = headerLogoConfig.images || {};
                const origImgs = originalHeaderLogoConfigRef.current.images || {};
                const hdrFails = [];
                await Promise.all(Object.keys(HDR_IMG_TYPES).map(async (field) => {
                    const file = imgs[`${field}__file`];
                    if (!file) {
                        // Slot emptied (no new pick, had an image at load): remove
                        // the file and clear IMG_{TYPE} server-side, like the legacy
                        // admin's delete button. Without this the refetch below
                        // simply brought the image back.
                        if (imgs[field] || !origImgs[field]) return;
                        const filename = String(origImgs[field]).split('?')[0].split('/').pop();
                        if (!filename) return;
                        try {
                            const del = await SftGlobalData.post('webshop&action=proxy', {
                                key:        props.api,
                                webshop_id: webshopId,
                                sftUserId:  props.login?.sft_user_id,
                                user:       props.login?.login,
                                method:     'DELETE',
                                path:       `/admin/images/general/${HDR_IMG_TYPES[field]}/${encodeURIComponent(filename)}`,
                                body:       null,
                            });
                            if (!del || !del.success) hdrFails.push(filename);
                        } catch {
                            hdrFails.push(filename);
                        }
                        return;
                    }
                    try {
                        const b64 = await fileToBase64(file);
                        const up = await SftGlobalData.post('webshop&action=proxy', {
                            key:        props.api,
                            webshop_id: webshopId,
                            sftUserId:  props.login?.sft_user_id,
                            user:       props.login?.login,
                            method:     'POST',
                            path:       `/admin/images/general/${HDR_IMG_TYPES[field]}`,
                            body:       { image_base64: b64, filename: file.name, mime: file.type || '' },
                        });
                        if (!up || !up.success) hdrFails.push(file.name);
                        // The favicon is stored, but the shop could not make the
                        // favicon.ico / app-icon sizes from it (format it cannot
                        // read, rights on icons/): say so instead of a silent
                        // "saved" while the shop keeps serving the old set.
                        else if (field === 'faviconUrl' && up.data?.icon_set?.status === false) {
                            const why = props.t ? props.t('cfg_header_images_favicon_set_failed', 'favicon sizes not created') : 'favicon sizes not created';
                            hdrFails.push(`${file.name} (${why}${up.data.icon_set.message ? `: ${up.data.icon_set.message}` : ''})`);
                        }
                    } catch {
                        hdrFails.push(file.name);
                    }
                }));
                if (hdrFails.length) warnings.push({ section: 'headerLogo', files: hdrFails });
            }

            // Cadeaubon voucher-layout assets — preview image, physical layout
            // image (base64), and the digital Unlayer design. Run AFTER the
            // layout CRUD so new layouts have a server id (mapped via layoutRef).
            if (cadeaubonLayoutsDirty) {
                const newLayIdByTemp = new Map();
                for (const r of results) {
                    if (r.kind === 'lay-new' && r.layoutRef && r.response?.success && r.response?.data?.id != null) {
                        newLayIdByTemp.set(r.layoutRef.tempId, r.response.data.id);
                    }
                }
                const layFails = [];
                const postLayout = (sid, slot, body) => SftGlobalData.post('webshop&action=proxy', {
                    key: props.api, webshop_id: webshopId, sftUserId: props.login?.sft_user_id,
                    user: props.login?.login, method: 'POST', path: `/cheques-layouts/${sid}/${slot}`, body,
                });
                await Promise.all(cadeaubonLayouts.map(async (l) => {
                    const sid = l.serverId ?? newLayIdByTemp.get(l.id);
                    if (sid == null) return;
                    if (l.imageFile) {
                        try {
                            const b64 = await fileToBase64(l.imageFile);
                            const up = await postLayout(sid, 'image', { image_base64: b64, filename: l.imageFile.name, mime: l.imageFile.type || '' });
                            if (!up || !up.success) layFails.push(l.imageFile.name);
                        } catch { layFails.push(l.imageFile.name); }
                    }
                    if (l.layoutImageFile && l.type === 'PHYSICAL') {
                        try {
                            const b64 = await fileToBase64(l.layoutImageFile);
                            const up = await postLayout(sid, 'layout-image', { image_base64: b64, filename: l.layoutImageFile.name, mime: l.layoutImageFile.type || '' });
                            if (!up || !up.success) layFails.push(l.layoutImageFile.name);
                        } catch { layFails.push(l.layoutImageFile.name); }
                    }
                    if (l.designDirty && l.type === 'DIGITAL') {
                        try {
                            const up = await postLayout(sid, 'layout', { html: l.html || '', design: l.design || {} });
                            if (!up || !up.success) layFails.push(`${l.description || 'layout'} (design)`);
                        } catch { layFails.push(`${l.description || 'layout'} (design)`); }
                    }
                }));
                if (layFails.length) warnings.push({ section: 'cadeaubonLayouts', files: layFails });
            }

            // Regenerate the storefront i18n JSON when a translation changed
            // (the look CTA label). Best-effort — the DB row is already saved.
            if (looksCtaSaved) {
                try {
                    await SftGlobalData.post('webshop&action=proxy', {
                        key:        props.api,
                        webshop_id: webshopId,
                        sftUserId:  props.login?.sft_user_id,
                        user:       props.login?.login,
                        method:     'GET',
                        path:       '/localization/generate',
                    });
                } catch { /* swallow — translation row is saved; JSON regen can be retried */ }
            }

            // Sync "saved" references so the dirty flags clear.
            if (containersDirty) {
                // Swap freshly-created client ids for their real pd_cnt-<id> in the
                // block lists so a follow-up save treats them as existing (PATCH).
                if (Object.keys(containerIdRemap).length) {
                    const remapBlock = (bk) => (containerIdRemap[bk.id] ? { ...bk, id: containerIdRemap[bk.id] } : bk);
                    setActive(l => l.map(remapBlock));
                    setAvailable(l => l.map(remapBlock));
                    setActive404(l => l.map(remapBlock));
                    setAvailable404(l => l.map(remapBlock));
                }
                originalContainerIdsRef.current = new Set(containerBlocks().map(bk => containerIdRemap[bk.id] || bk.id));
                setContainersDirty(false);
            }
            if (orderDirty)         setHomeSectionsOrder(remapOrder(desiredHomeSectionsOrder));
            if (saved('order') && homeBlockFlagsRef) {
                const activeIds = String(desiredHomeSectionsOrder || '').split(',').map(x => x.trim());
                homeBlockFlagsRef.current = Object.fromEntries(Object.entries(homeBlockFlagsRef.current || {})
                    .map(([id, was]) => [id, was === undefined ? undefined : activeIds.includes(id)]));
            }
            if (showLandingDirty)   setSavedShowLanding(showLanding);
            if (order404Dirty)      setPage404SectionsOrder(remapOrder(desiredPage404Order));
            if (productGridDirty)   originalProductGridConfigRef.current = productGridConfig;
            if (productCardDirty)   originalProductCardConfigRef.current = productCardConfig;
            if (styleSettingsDirty) originalStyleSettingsRef.current     = styleSettings;
            if (groupsFilterDirty)  originalGroupsFilterConfigRef.current = groupsFilterConfig;
            if (globalWidthsDirty)  originalGlobalWidthsRef.current        = globalWidths;
            // headerLogo: snapshot happens in the refetch block below (so newly
            // uploaded image URLs land and the pending `__file` markers clear).
            if (navigationDirty)    originalNavigationConfigRef.current    = navigationConfig;
            // Navbar order: plain snapshot — the PATCHed order_index values are
            // already what the rows hold (no server-assigned ids involved).
            if (navbarOrderDirty)   originalNavbarOrderRef.current         = navbarOrder;
            // Footer: settings parts are picked up by the simple ref sync
            // below; the external-links arrays need a refetch so freshly
            // POSTed rows get their serverId (and any DELETEd id is cleared).
            // We do the actual refetch in the block further down once all
            // ops have settled — for now just snapshot non-list fields.
            if (footerDirty)        originalFooterConfigRef.current        = {
                ...footerConfig,
                customLinks: originalFooterConfigRef.current.customLinks,
                socialMedia: originalFooterConfigRef.current.socialMedia,
            };
            // Contents-backed blocks (static pages + the extra-footer columns)
            // must come BACK from the server: the mini-api re-hosts every
            // Unlayer-CDN image on save (ImageRehoster) — assets.unlayer.com/…
            // becomes <shop>/<img-repo>/library/unlayer-<hash>.png — so the
            // local state we just sent is NOT what's stored. Keeping it as the
            // baseline left the editor pointing at the CDN copy: harmless while
            // that copy lives, but once Unlayer purges it the next save writes
            // the dead CDN url straight over the working local one.
            // ---- Post-save refetches ----------------------------------------
            // Every dirty section re-reads its server state below. The GETs
            // are independent, so fire them all at once (they used to run
            // one-by-one — ~10 serialized proxy round-trips on a broad save)
            // and de-dupe by path (settings-collections feeds both banners
            // and the footer external links).
            const refetchNeeds = [
                [staticPagesDirty || extraFooterDirty, '/admin/settings-contents'],
                [cadeaubonPlaceholdersDirty, '/cheque-placeholders'],
                [cadeaubonLayoutsDirty, '/cheques-layouts'],
                [customerGroupsDirty, '/admin/customer-category-groups'],
                [dynamicPagesDirty, '/dynamic-pages'],
                [bannersDirty || (footerDirty && externalLinkOps.length > 0), '/admin/settings-collections'],
                [carouselDirty, '/admin/carousel'],
                [imageGridDirty, '/admin/image-grid'],
                [headerLogoDirty, '/admin/settings-core'],
            ];
            const prefetched = {};
            await Promise.all([...new Set(refetchNeeds.filter(([need]) => need).map(([, p]) => p))].map(p =>
                SftGlobalData.post('webshop&action=proxy', {
                    key:        props.api,
                    webshop_id: webshopId,
                    sftUserId:  props.login?.sft_user_id,
                    user:       props.login?.login,
                    method:     'GET',
                    path:       p,
                }).then(r => { prefetched[p] = r; }).catch(() => { prefetched[p] = null; })));

            const contentsRefreshNeeded = staticPagesDirty || extraFooterDirty;
            let refreshedContents = null;
            if (contentsRefreshNeeded) {
                try {
                    const rc = prefetched['/admin/settings-contents'];
                    if (rc?.success && rc.data && typeof rc.data === 'object') refreshedContents = rc.data;
                } catch { /* fall back to the local state below */ }
            }
            // Same mapping as the load path (pageFromContents / columnFromContents)
            // so a refreshed row is shaped exactly like a freshly loaded one.
            const rowToPage = contentsRowToPage;     // shared (F32)
            const rowToColumn = contentsRowToColumn; // shared (F32)
            if (extraFooterDirty) {
                if (refreshedContents) {
                    const reloadedFooter = {
                        ...extraFooterConfig,
                        columns: {
                            1: rowToColumn(refreshedContents.contents_footer_1),
                            2: rowToColumn(refreshedContents.contents_footer_2),
                            3: rowToColumn(refreshedContents.contents_footer_3),
                        },
                    };
                    setExtraFooterConfig(reloadedFooter);
                    originalExtraFooterConfigRef.current = reloadedFooter;
                } else {
                    originalExtraFooterConfigRef.current = extraFooterConfig;
                }
            }
            if (staticPagesDirty) {
                if (refreshedContents) {
                    const attrByKey = {
                        about: 'contents_about', disclaimer: 'contents_disclaimer',
                        privacy: 'contents_privacy', page404: 'contents_404',
                        intro: 'contents_intro', detail: 'contents_detail',
                    };
                    const reloadedPages = { ...staticPages };
                    for (const [key, field] of Object.entries(attrByKey)) {
                        if (refreshedContents[field]) reloadedPages[key] = rowToPage(refreshedContents[field]);
                    }
                    setStaticPages(reloadedPages);
                    originalStaticPagesRef.current = reloadedPages;
                } else {
                    originalStaticPagesRef.current = staticPages;
                }
            }
            if (storesDirty)        originalStoresRef.current              = stores;
            if (separatorDirty)     originalHoursSeparatorRef.current      = hoursSeparator;
            if (mapSettingsDirty)   originalMapSettingsRef.current         = mapSettings;
            if (cardsDirty)         originalCardsRef.current               = cards;
            if (cardsDirty && originalCartLayoutRef) originalCartLayoutRef.current = cartLayout;
            if (brandsConfigDirty)  originalBrandsConfigRef.current        = brandsConfig;
            if (looksConfigDirty)   originalLooksConfigRef.current         = looksConfig;
            if (overigeConfigDirty) originalOverigeConfigRef.current       = overigeConfig;
            // Synchronisatie: scalar settings only, no server-assigned ids.
            if (syncConfigDirty)    originalSyncConfigRef.current          = syncConfig;
            // Cadeaubon settings have no server-assigned ids, so a plain
            // snapshot clears the dirty flag.
            if (cadeaubonConfigDirty) originalCadeaubonConfigRef.current   = cadeaubonConfig;
            // Verwerking: snapshot the config and the rebuilt discount JSON so the
            // dirty flags clear (no server-assigned ids, so no refetch needed).
            if (processingConfigDirty) {
                // If the guest id was skipped (invalid), keep its original value in
                // the snapshot so the field stays flagged dirty/unsaved until fixed.
                const prevGuest = originalProcessingConfigRef.current.access?.guestCustomerId ?? '';
                originalProcessingConfigRef.current = guestIdSkipped
                    ? { ...processingConfig, access: { ...processingConfig.access, guestCustomerId: prevGuest } }
                    : processingConfig;
                const prev = originalProcChequeRef.current;
                const rebuild = (base, field) => {
                    const out = { ...(base || {}) };
                    Object.keys(processingConfig.discountTypes || {}).forEach((c6) => {
                        out[`99${c6}`] = !!(processingConfig.discountTypes[c6] || {})[field];
                    });
                    return out;
                };
                originalProcChequeRef.current = {
                    allowed:      rebuild(prev.allowed,      'enabled'),
                    asPayment:    rebuild(prev.asPayment,    'acceptAsPayment'),
                    addToReceipt: rebuild(prev.addToReceipt, 'showInEmail'),
                };
                // Sync the ticket-module baseline to what was effectively written.
                const om = originalTicketModuleRef.current;
                originalTicketModuleRef.current = (processingConfig.payments?.location === 'noCheckout')
                    ? 'LOOKBOOK'
                    : (om === 'LOOKBOOK' ? 'RESERVATION' : om);
            }
            // Cadeaubon translations: refetch so freshly-POSTed placeholders pick
            // up their server id + generated PLC_* key (otherwise the next save
            // would re-POST them).
            if (cadeaubonPlaceholdersDirty) {
                try {
                    const refreshPlc = prefetched['/cheque-placeholders'];
                    const plcRows2 = (refreshPlc?.success && Array.isArray(refreshPlc.data)) ? refreshPlc.data : null;
                    const reloadedPlc = plcRows2 ? plcRows2.map(placeholderRowToForm) : cadeaubonPlaceholders;
                    setCadeaubonPlaceholders(reloadedPlc);
                    originalPlaceholdersRef.current = reloadedPlc;
                } catch {
                    originalPlaceholdersRef.current = cadeaubonPlaceholders;
                }
            }
            // Voucher layouts: refetch so new POSTs get their server id + the
            // new image filenames land (and pending picks/design flags clear).
            if (cadeaubonLayoutsDirty) {
                try {
                    const refreshLay = prefetched['/cheques-layouts'];
                    const layRows2 = (refreshLay?.success && Array.isArray(refreshLay.data)) ? refreshLay.data : null;
                    // Image prefix captured at load time — no dump round-trip.
                    const reloadedLay = layRows2 ? layRows2.map(r => layoutRowToForm(r, layoutImgBaseRef.current)) : cadeaubonLayouts;
                    setCadeaubonLayouts(reloadedLay);
                    originalCadeaubonLayoutsRef.current = reloadedLay;
                } catch {
                    originalCadeaubonLayoutsRef.current = cadeaubonLayouts;
                }
            }
            // Custom customer fields: refetch the settings dump so freshly-POSTed
            // groups get their server id (else the next save re-POSTs them).
            if (customerGroupsDirty) {
                try {
                    // Dedicated list endpoint (mini-api GET added 2026-06-04) —
                    // avoids re-pulling the whole /admin/settings dump.
                    const refreshCcg = prefetched['/admin/customer-category-groups'];
                    const ccgRows2 = (refreshCcg?.success && Array.isArray(refreshCcg.data))
                        ? refreshCcg.data
                        : null;
                    const reloadedCcg = ccgRows2 ? ccgRows2.map(customerGroupRowToForm) : customerCategoryGroups;
                    setCustomerCategoryGroups(reloadedCcg);
                    originalCustomerGroupsRef.current = reloadedCcg;
                } catch {
                    originalCustomerGroupsRef.current = customerCategoryGroups;
                }
            }
            // Dynamic pages: refetch so freshly-POSTed pages pick up their real
            // id and edited `content` resets (designs re-lazy-load on next view).
            if (dynamicPagesDirty) {
                try {
                    const refreshDyn = prefetched['/dynamic-pages'];
                    const dynRows2 = (refreshDyn?.success && Array.isArray(refreshDyn.data)) ? refreshDyn.data : null;
                    const reloaded = dynRows2 ? dynRows2.map(dynRowToPage) : dynamicPages;
                    setDynamicPages(reloaded);
                    originalDynamicPagesRef.current = reloaded;
                } catch {
                    originalDynamicPagesRef.current = dynamicPages;
                }
            }
            // Banners: there's no admin-wide GET list endpoint (the public
            // /information-banner filters by active+date), so refetch the
            // collections bundle and re-extract `informationBanners` to pick
            // up fresh ids for newly-POSTed banners.
            if (bannersDirty) {
                try {
                    const refreshSet = prefetched['/admin/settings-collections'];
                    const bannerRows2 = (refreshSet?.success && Array.isArray(refreshSet.data?.informationBanners))
                        ? refreshSet.data.informationBanners
                        : null;
                    const reloaded = bannerRows2 ? bannerRows2.map(bannerRowToForm) : banners;
                    setBanners(reloaded);
                    originalBannersRef.current = reloaded;
                } catch {
                    originalBannersRef.current = banners;
                }
            }
            if (imageGalleryDirty)  originalImageGalleryConfigRef.current  = imageGalleryConfig;
            if (productDetailInfoDirty) {
                // titleAndUrl `saved` follows what was just written (shown raw
                // to SoftTouch users on the Product title & URL card).
                originalProductDetailInfoConfigRef.current = {
                    ...productDetailInfoConfig,
                    titleAndUrl: withSavedTitleUrl(productDetailInfoConfig.titleAndUrl, originalProductDetailInfoConfigRef.current.titleAndUrl),
                };
            }
            // For carousel, refetch /admin/settings after CRUD to repopulate
            // serverIds (new POSTs need their fresh row id; without it the
            // next save would re-POST them). Falls back to the working
            // carouselConfig if the refetch hits an error.
            if (carouselDirty) {
                try {
                    // Dedicated list endpoint — much lighter than re-pulling
                    // the whole /admin/settings dump for one table.
                    const refresh = prefetched['/admin/carousel'];
                    const rows = (refresh?.success && Array.isArray(refresh?.data)) ? refresh.data : null;
                    if (rows) {
                        // Shared mapper (F32) — identical to the load path.
                        const byLang2 = (lang) => rowsByLang(rows, lang, (r, i) => slideRowToForm(r, i, carouselImgBaseRef.current));
                        const refreshedCarousel = {
                            ...carouselConfig,
                            slides: { nl: byLang2('nl'), en: byLang2('en'), fr: byLang2('fr') },
                        };
                        setCarouselConfig(refreshedCarousel);
                        originalCarouselConfigRef.current = refreshedCarousel;
                    } else {
                        originalCarouselConfigRef.current = carouselConfig;
                    }
                } catch {
                    originalCarouselConfigRef.current = carouselConfig;
                }
            }
            // Same dance for the image-grid: refetch after CRUD so new POSTs
            // get their server-assigned row ids before the next save.
            if (imageGridDirty) {
                try {
                    // Dedicated list endpoint — much lighter than re-pulling
                    // the whole /admin/settings dump for one table.
                    const refresh = prefetched['/admin/image-grid'];
                    const rows = (refresh?.success && Array.isArray(refresh?.data)) ? refresh.data : null;
                    if (rows) {
                        // Shared mapper (F32) — identical to the load path.
                        const gridByLang3 = (lang) => rowsByLang(rows, lang, (r, i) => gridCellRowToForm(r, i, gridImgBaseRef.current));
                        const refreshedImageGrid = {
                            ...imageGridConfig,
                            cells: { nl: gridByLang3('nl'), en: gridByLang3('en'), fr: gridByLang3('fr') },
                        };
                        setImageGridConfig(refreshedImageGrid);
                        originalImageGridConfigRef.current = refreshedImageGrid;
                    } else {
                        originalImageGridConfigRef.current = imageGridConfig;
                    }
                } catch {
                    originalImageGridConfigRef.current = imageGridConfig;
                }
            }
            // Header/logo: refetch after image uploads so the new IMG_ URLs land
            // and the pending `__file` markers clear (otherwise it stays dirty).
            // The core bundle carries the computed img_store_* URLs.
            if (headerLogoDirty) {
                try {
                    const refresh = prefetched['/admin/settings-core'];
                    if (refresh?.success && refresh.data) {
                        const s4 = refresh.data;
                        const hdrBase4 = shopImageBase(props.selectedWebshop?.display_name);
                        const px = (u) => (u ? `${hdrBase4}${u}` : '');
                        const refreshedHeaderLogo = {
                            size: { ...headerLogoConfig.size },
                            images: {
                                logoUrl:       px(s4.img_store_logo),
                                backgroundUrl: px(s4.img_store_header),
                                faviconUrl:    px(s4.img_store_icon),
                            },
                        };
                        setHeaderLogoConfig(refreshedHeaderLogo);
                        originalHeaderLogoConfigRef.current = refreshedHeaderLogo;
                    } else {
                        originalHeaderLogoConfigRef.current = headerLogoConfig;
                    }
                } catch {
                    originalHeaderLogoConfigRef.current = headerLogoConfig;
                }
            }
            // Footer external-links: refetch so freshly POSTed rows get a
            // serverId. We only need to refresh the customLinks/socialMedia
            // arrays — newsletter is already snapshotted above.
            if (footerDirty && externalLinkOps.length > 0) {
                try {
                    const refresh = prefetched['/admin/settings-collections'];
                    const links = (refresh?.success && Array.isArray(refresh?.data?.externalLinks)) ? refresh.data.externalLinks : null;
                    if (links) {
                        const toFooter = linkRowToFooter; // shared (F32)
                        const toSocial = linkRowToSocial; // shared (F32)
                        const refreshedFooter = {
                            ...footerConfig,
                            customLinks: links.filter(r => String(r.position || '').toUpperCase() !== 'SOCIAL').map(toFooter),
                            socialMedia: links.filter(r => String(r.position || '').toUpperCase() === 'SOCIAL').map(toSocial),
                        };
                        setFooterConfig(refreshedFooter);
                        originalFooterConfigRef.current = refreshedFooter;
                    }
                } catch { /* swallow — snapshot already in place */ }
            }

            // Merken-content rides the global save too. Prefer the mounted
            // card's own saver (it also refreshes the card's baseline); when
            // the card is unmounted (other tab open) flush the session
            // snapshot directly. A failure lands in the report like any other
            // section and leaves the card dirty.
            if (brandContentDirty) {
                try {
                    if (brandContentSaveRef?.current) {
                        await brandContentSaveRef.current();
                    } else if (brandContentSessionRef?.current?.brand) {
                        const sess = brandContentSessionRef.current;
                        const bcRes = await SftGlobalData.post('webshop&action=proxy', {
                            key:        props.api,
                            webshop_id: webshopId,
                            sftUserId:  props.login?.sft_user_id,
                            user:       props.login?.login,
                            method:     'POST',
                            path:       `/brand-content/${encodeURIComponent(sess.brand.id)}`,
                            body:       brandContentFormToBody(sess.form),
                        });
                        if (!bcRes?.success) {
                            throw new Error(bcRes?.message || 'Merken-content opslaan mislukt.');
                        }
                        sess.baseline = JSON.stringify(sess.form);
                    }
                    if (setBrandContentDirty) setBrandContentDirty(false);
                } catch (e) {
                    extraFailures.push({ section: 'brandContent', message: e?.message || '' });
                }
            }
            })({
                containersDirty: saved('containers'),
                orderDirty: saved('order'),
                showLandingDirty: saved('showLanding'),
                order404Dirty: saved('order404'),
                productGridDirty: saved('productGrid'),
                productCardDirty: saved('productCard'),
                styleSettingsDirty: saved('styleSettings'),
                groupsFilterDirty: saved('groupsFilter'),
                globalWidthsDirty: saved('globalWidths'),
                headerLogoDirty: saved('headerLogo'),
                navigationDirty: saved('navigation'),
                navbarOrderDirty: saved('navbarOrder'),
                footerDirty: saved('footer'),
                extraFooterDirty: saved('extraFooter'),
                staticPagesDirty: saved('staticPages'),
                cardsDirty: saved('cards'),
                brandsConfigDirty: saved('brandsConfig'),
                overigeConfigDirty: saved('overige'),
                cadeaubonConfigDirty: saved('cadeaubonConfig'),
                cadeaubonPlaceholdersDirty: saved('cadeaubonPlaceholders'),
                cadeaubonLayoutsDirty: saved('cadeaubonLayouts'),
                processingConfigDirty: saved('processing'),
                syncConfigDirty: saved('sync'),
                customerGroupsDirty: saved('customerGroups'),
                looksConfigDirty: saved('looks'),
                imageGalleryDirty: saved('imageGallery'),
                productDetailInfoDirty: saved('pdi'),
                carouselDirty: saved('carousel'),
                imageGridDirty: saved('imageGrid'),
                mapSettingsDirty: saved('map'),
                bannersDirty: saved('banners'),
                dynamicPagesDirty: saved('dynamicPages'),
                brandContentDirty: saved('brandContent'),
                storesDirty:    storesDirty    && !failedSections.has('stores'),
                separatorDirty: separatorDirty && !failedSections.has('stores'),
            });

            const report = buildSaveReport({ dirty: dirtySections, failedOps, extra: extraFailures, warnings });
            if (report.ok && report.warnings.length === 0) {
                // User-facing wording: "regenerating statics" is developer jargon —
                // what the admin cares about is that the shop is picking the
                // changes up (the statics regenerate is exactly that propagation).
                if (props.notify) props.notify(props.t ? props.t('cfg_saved_propagating', 'Opgeslagen — de webshop verwerkt de wijzigingen…') : 'Opgeslagen — de webshop verwerkt de wijzigingen…', 4000, 'top-right', props.theme, 2);
                if (setSaveReport) setSaveReport(null);
            } else if (setSaveReport) {
                // Something was not saved: a dialog that names the sections, not
                // a toast that is gone in six seconds.
                setSaveReport(report);
            } else if (props.notify) {
                const msg = report.failed.flatMap(f => f.errors.map(er => `${er.path}: ${er.message || 'failed'}`)).join(' · ');
                props.notify('Save failed: ' + msg, 6000, 'top-right', props.theme, 1);
            }
            if (guestIdSkipped && props.notify) props.notify('Guest customer ID was not saved — no customer with that ID exists.', 6000, 'top-right', props.theme, 1);
            if (report.saved.length) {
                // Fire the legacy generate_statics.php script so the storefront
                // picks up what was saved without waiting for the next cron tick.
                // Silent while the report is up: a green "regenerated" toast next
                // to "not everything was saved" reads as if all went well.
                fireGenerateStatics(null, { silent: !(report.ok && report.warnings.length === 0) });
                // Carousel/image-grid JSON is only force-rewritten via ?detail (the
                // plain run skips it unless the row changed in the last 11 min, and
                // an image upload doesn't bump updated_at). Mirror the legacy admin
                // and force those generators so new images show immediately.
                if (saved('carousel'))  fireGenerateStatics('__generateCarousel',  { silent: true });
                if (saved('imageGrid')) fireGenerateStatics('__generateImageGrid', { silent: true });
                // settings.json (what the storefront boots from) also carries the
                // product containers, voucher layouts and customer groups, but the
                // plain run only rewrites it when a settings row changed. Force it
                // when one of those was saved (the legacy admin did this for the
                // voucher layouts).
                if (saved('containers') || saved('cadeaubonLayouts') || saved('customerGroups')) {
                    fireGenerateStatics('__generateSettings', { silent: true });
                }
            }
            // Baseline refs were just updated — force every dirty useMemo to
            // recompute so the Save button clears (see savedTick declaration).
            setSavedTick(t => t + 1);
            return report;
        } catch (e) {
            // Unexpected: we no longer know what reached the shop. Say so.
            const report = { ok: false, unexpected: true, saved: [], warnings: [], failed: [{ section: 'other', blockedBy: null, errors: [{ method: '', path: '', message: e?.message || 'network error' }] }] };
            if (setSaveReport) setSaveReport(report);
            else if (props.notify) props.notify('Save failed: ' + (e?.message || 'network error'), 6000, 'top-right', props.theme, 1);
            return report;
        } finally {
            setConfigSaving(false);
        }
};
